import type { TranslationKey } from "./en";

// Thai copy. Every key in en.ts must be here (test/i18n.test.ts). Server
// codes, ids and currency codes stay as they are.
export const th: Partial<Record<TranslationKey, string>> = {
  "app.name": "พอร์ทัลโบรกเกอร์",
  "language.label": "ภาษา",
  "language.english": "อังกฤษ",
  "language.thai": "ไทย",

  "common.loading": "กำลังโหลด…",
  "common.cancel": "ยกเลิก",
  "common.close": "ปิด",
  "common.done": "เสร็จสิ้น",
  "common.clear": "ล้าง",
  "common.search": "ค้นหา",
  "common.all": "ทั้งหมด",
  "common.yes": "ใช่",
  "common.no": "ไม่",
  "common.status": "สถานะ",
  "common.actions": "การดำเนินการ",
  "common.when": "เวลา",
  "common.reason": "เหตุผล",
  "common.reasonRequired": "เหตุผล (จำเป็น)",
  "common.reasonOptional": "เหตุผล (ไม่บังคับ)",
  "common.reasonMissing": "โปรดระบุเหตุผล ระบบจะบันทึกไว้ในประวัติการตรวจสอบ",
  "common.reasonHint": "บันทึกพร้อมการเปลี่ยนแปลงในประวัติการตรวจสอบของโบรกเกอร์",
  "common.reload": "โหลดใหม่",
  "common.loadMore": "โหลดเพิ่ม",
  "common.prev": "ก่อนหน้า",
  "common.next": "ถัดไป",
  "common.pagination": "การแบ่งหน้า",
  "common.range": "{from}–{to} จาก {total}",
  "common.pageNumber": "หน้า {page}",
  "common.asOf": "ข้อมูล ณ",

  "error.pageTitle": "เกิดข้อผิดพลาด",
  "error.serverSaid": "เซิร์ฟเวอร์แจ้งว่า: {message}",
  "error.requestId": "รหัสคำขอ: {id}",
  "error.rule": "กฎ",
  "dialog.unknownOutcome": "ไม่ทราบผลลัพธ์: เซิร์ฟเวอร์อาจบันทึกการเปลี่ยนแปลงนี้แล้วหรือยังไม่ได้บันทึกก็ได้ โปรดโหลดหน้าใหม่และตรวจสอบก่อนลองอีกครั้ง การส่งซ้ำอาจทำให้บันทึกซ้ำสองครั้ง",
  "dialog.refreshPage": "โหลดหน้าใหม่",
  "guard.title": "บทบาทของคุณใช้หน้านี้ไม่ได้",
  "guard.body": "หน้านี้ต้องมีสิทธิ์ {capability} บนโหนดที่เลือก คำตอบจากเซิร์ฟเวอร์แสดงอยู่ด้านล่าง",
  "notFound.title": "ไม่พบหน้า",
  "notFound.body": "ไม่มีหน้าของพอร์ทัลที่ที่อยู่นี้",
  "notFound.home": "ไปที่ภาพรวม",

  "capability.VIEW": "ดูข้อมูล",
  "capability.FINANCE_VIEW": "ดูข้อมูลการเงิน",
  "capability.STAFF_MANAGE": "จัดการพนักงาน",
  "capability.CHILD_CREATE": "สร้างโบรกเกอร์ย่อย",
  "capability.ACCOUNT_PAUSE": "พักบัญชีผู้ใช้",
  "capability.FUNDING_REQUEST": "ขอโอนเงินทุน",
  "capability.FEE_MANAGE": "จัดการแผนค่าธรรมเนียมและแผนแบ่งรายได้",
  "capability.BRANDING_MANAGE": "เปลี่ยนรูปสกุลเงิน",
  "role.OWNER": "เจ้าของ",
  "role.ADMINISTRATOR": "ผู้ดูแล",
  "role.FINANCE": "การเงิน",
  "role.TRADER": "ผู้ซื้อขาย",
  "role.VIEWER": "ผู้ดู",
  "membershipStatus.INVITED": "ได้รับเชิญ",
  "membershipStatus.ACTIVE": "ใช้งานอยู่",
  "membershipStatus.SUSPENDED": "ถูกระงับ",
  "membershipStatus.REMOVED": "ถูกนำออก",
  "brokerStatus.DRAFT": "ฉบับร่าง",
  "brokerStatus.ACTIVE": "ใช้งานอยู่",
  "brokerStatus.PAUSED": "พักการทำงาน",
  "brokerStatus.CLOSING": "กำลังปิด",
  "brokerStatus.CLOSED": "ปิดแล้ว",
  "status.explain.DRAFT": "รอการอนุมัติจากตลาด โหนดฉบับร่างรับผู้ใช้ เงินทุน หรือคำสั่งซื้อขายไม่ได้จนกว่าจะได้รับอนุมัติ",
  "status.explain.ACTIVE": "ทำงานเต็มรูปแบบ: ให้บริการผู้ใช้ จัดสรรเงินทุน และซื้อขายได้ภายใต้วงเงินของตลาด",
  "status.explain.PAUSED": "หยุดการสร้างความเสี่ยงใหม่ ไม่มีคำสั่งซื้อขาย การจัดสรร หรือบัญชีใหม่ การลดความเสี่ยง (ยกเลิกคำสั่ง ลดสถานะ คืนเงิน ชำระราคา และจ่ายเงิน) ยังทำได้ มีเพียงตลาดที่เปิดใช้งานอีกครั้งได้",
  "status.explain.CLOSING": "กำลังยุติการทำงาน: ไม่มีสิ่งใหม่เริ่มขึ้น และกำลังเคลียร์ภาระที่ค้างอยู่ก่อนที่ตลาดจะปิดโหนด",
  "status.explain.CLOSED": "ปิดแล้ว ยังดูประวัติได้ แต่ไม่สามารถเปลี่ยนแปลงสิ่งใดได้",
  "accountStatus.ACTIVE": "ใช้งานอยู่",
  "accountStatus.SUSPENDED": "ถูกระงับ",
  "accountStatus.CLOSED": "ปิดแล้ว",
  "balanceMode.SYSTEM_BROKER": "โบรกเกอร์ระบบ",
  "balanceMode.BROKER_FUNDED": "โบรกเกอร์จัดสรรเงินทุน",
  "balanceMode.THIRD_PARTY_CREDIT": "เครดิตจากบุคคลที่สาม",
  "entryPath.REGISTRATION": "การลงทะเบียน",
  "entryPath.SOCIAL_REGISTRATION": "ลงทะเบียนผ่านโซเชียล",
  "entryPath.LOGIN_RECOVERY": "กู้คืนจากการเข้าสู่ระบบ",
  "entryPath.PROVIDER_LAUNCH": "เปิดจากผู้ให้บริการ",
  "entryPath.BACKFILL": "นำเข้าย้อนหลัง",
  "positionStatus.OPEN": "เปิดอยู่",
  "positionStatus.CLOSED": "ปิดแล้ว",
  "positionStatus.RESOLVED": "ประกาศผลแล้ว",
  "positionStatus.REDEEMABLE": "แลกรับได้",
  "positionStatus.REDEEMED": "แลกรับแล้ว",
  "positionStatus.LOST": "แพ้",
  "positionStatus.REFUNDED": "คืนเงินแล้ว",
  "loginMethod.PASSWORD": "รหัสผ่าน",
  "loginMethod.MFA": "รหัสยืนยันสองขั้นตอน",
  "loginMethod.GOOGLE": "Google",
  "loginMethod.EMAIL_CONFIRM": "ยืนยันอีเมล",
  "loginMethod.PROVIDER_LAUNCH": "เปิดจากผู้ให้บริการ",
  "orderChannel.WEB": "เว็บ",
  "orderChannel.EXTERNAL_LAUNCH": "เปิดจากผู้ให้บริการ",
  "orderChannel.OPENAPI": "Open API",
  "orderSide.BUY": "ซื้อ",
  "orderSide.SELL": "ขาย",
  "orderStatus.NEW": "สร้างแล้ว",
  "orderStatus.RESERVED": "กันเงินแล้ว",
  "orderStatus.PENDING_ENGINE": "รอระบบจับคู่",
  "orderStatus.PENDING_FUNDING": "รอยืนยันเงินทุน",
  "orderStatus.OPEN": "เปิดอยู่",
  "orderStatus.PARTIALLY_FILLED": "จับคู่แล้วบางส่วน",
  "orderStatus.CANCEL_PENDING": "กำลังยกเลิก",
  "orderStatus.FILLED": "จับคู่ครบแล้ว",
  "orderStatus.CANCELED": "ยกเลิกแล้ว",
  "orderStatus.REJECTED": "ถูกปฏิเสธ",
  "orderStatus.EXPIRED": "หมดอายุ",
  "orderStatus.FAILED": "ล้มเหลว",
  "tif.GTC": "มีผลจนกว่าจะยกเลิก",
  "tif.GTD": "มีผลถึงวันที่กำหนด",
  "tif.FOK": "จับคู่ทั้งหมดทันทีหรือยกเลิก",
  "tif.FAK": "จับคู่ทันทีแล้วยกเลิกส่วนที่เหลือ",
  "liquidity.MAKER": "เมกเกอร์",
  "liquidity.TAKER": "เทกเกอร์",
  "ledgerStatus.PENDING": "รอดำเนินการ",
  "ledgerStatus.COMMITTED": "บันทึกแล้ว",
  "ledgerStatus.FAILED": "ล้มเหลว",
  "fundingRole.MASTER": "บัญชีหลัก",
  "fundingRole.POOL": "พูล",
  "transferKind.POOL_ALLOCATION": "จัดสรรพูล",
  "transferKind.POOL_RETURN": "คืนพูล",
  "transferKind.USER_ALLOCATION": "จัดสรรให้ผู้ใช้",
  "transferKind.USER_RETURN": "รับคืนจากผู้ใช้",
  "transferState.PENDING": "รอดำเนินการ",
  "transferState.COMMITTED": "สำเร็จ",
  "transferState.FAILED": "ล้มเหลว",
  "transferState.MANUAL_REVIEW": "รอตรวจสอบด้วยตนเอง",
  "actorKind.BROKER_CREDENTIAL": "ข้อมูลรับรองเซิร์ฟเวอร์",
  "actorKind.EXCHANGE_ADMIN": "ตลาด",
  "actorKind.BROKER_STAFF": "พนักงาน",
  "actorKind.SYSTEM": "ระบบ",
  "actor.exchange": "ตลาด",
  "earningState.PENDING": "รอดำเนินการ",
  "earningState.AVAILABLE": "พร้อมใช้",
  "earningState.PAYOUT_RESERVED": "กันไว้สำหรับจ่าย",
  "earningState.PAID": "จ่ายแล้ว",
  "earningState.VOID": "เป็นโมฆะ",
  "earningState.REASSIGNED": "โอนย้ายแล้ว",
  "earningOrigin.EARNED": "รายได้",
  "earningOrigin.ADJUSTMENT": "การปรับปรุง",
  "earningOrigin.REASSIGNMENT": "การโอนย้าย",
  "revenueRole.maker": "เมกเกอร์",
  "revenueRole.taker": "เทกเกอร์",
  "revenueRole.redemption": "การแลกรับ",
  "reconState.RUNNING": "กำลังทำงาน",
  "reconState.MATCHED": "ตรงกัน",
  "reconState.MISMATCH": "ไม่ตรงกัน",
  "reconState.FAILED": "ล้มเหลว",
  "fundingRecon.OK": "สมดุล",
  "fundingRecon.FINDINGS": "พบข้อสังเกต",
  "fundingRecon.FAILED": "ล้มเหลว",
  "schedule.WEEKLY": "รายสัปดาห์",
  "schedule.MONTHLY": "รายเดือน",
  "schedule.MANUAL": "ชุดที่สร้างด้วยตนเอง",
  "feeScope.GROUP": "ทั้งกลุ่ม",
  "feeScope.BRANCH": "สาขา",
  "feeScope.NODE": "เฉพาะโหนดนี้",
  "statementRow.EARNING": "รายได้",
  "statementRow.REASSIGNED_OUT": "โอนย้ายออก",
  "statementRow.PAYOUT": "การจ่ายเงิน",
  "clearing.direction.WE_OWE_BROKER": "ตามบัญชีแยกประเภท ตลาดค้างชำระโบรกเกอร์นี้ (ผู้ใช้ของโบรกเกอร์ได้กำไรสุทธิ)",
  "clearing.direction.BROKER_OWES_US": "ตามบัญชีแยกประเภท โบรกเกอร์นี้ค้างชำระตลาด (ผู้ใช้ใช้ไปมากกว่าที่ได้รับคืน)",
  "clearing.direction.FLAT": "บัญชีแยกประเภทเสมอกัน: ไม่มีฝ่ายใดค้างชำระ",
  "clearing.owed": "ยอดขาดดุลตามบัญชีแยกประเภท ก่อนหักการชำระ:",
  "clearing.none": "ไม่มีบัญชีชำระ เพราะโหนดนี้ไม่ได้ให้บริการบัญชีเครดิตจากบุคคลที่สาม",
  "coverage.node": "เฉพาะโหนดนี้",
  "coverage.subtree": "รวมโหนดลูกหลาน",
  "coverage.split": "แยกของโหนดนี้และโหนดลูกหลาน",

  "nav.aria": "เมนูพอร์ทัล",
  "nav.version": "พอร์ทัลโบรกเกอร์ · SM-621",
  "nav.inheritedAccess": "สิทธิ์ผ่านโหนดแม่",
  "nav.section.overview": "ภาพรวม",
  "nav.section.organization": "องค์กร",
  "nav.section.trading": "การซื้อขาย",
  "nav.section.money": "การเงิน",
  "nav.overview": "ภาพรวม",
  "nav.organization": "องค์กร",
  "nav.hierarchy": "ลำดับชั้น",
  "nav.staff": "พนักงาน",
  "nav.users": "ผู้ใช้",
  "nav.positions": "สถานะการถือครองปัจจุบัน",
  "nav.orders": "คำสั่งที่เปิดอยู่",
  "nav.orderHistory": "ประวัติคำสั่งซื้อขาย",
  "nav.trades": "ประวัติการซื้อขาย",
  "nav.risk": "ความเสี่ยง",
  "nav.fees": "ค่าธรรมเนียม",
  "nav.feePlans": "จัดการแผน",
  "nav.funding": "เงินทุน",
  "nav.revenue": "รายได้",
  "nav.payouts": "การจ่ายเงิน",
  "nav.statements": "รายงานสรุป",
  "nav.reconciliation": "การกระทบยอด",
  "nav.settlement": "การชำระยอด",
  "topbar.openNavigation": "เปิดเมนู",
  "topbar.skipToContent": "ข้ามไปยังเนื้อหา",
  "topbar.currency": "สกุลเงิน",
  "topbar.currencyOnly": "โหนดนี้ซื้อขายด้วย {currency} เท่านั้น",
  "topbar.account": "เมนูบัญชี",
  "topbar.brokerStaff": "พนักงานโบรกเกอร์",
  "topbar.signOut": "ออกจากระบบ",
  "topbar.signingOut": "กำลังออกจากระบบ…",
  "topbar.security": "ความปลอดภัย",
  "node.label": "โหนด",
  "node.choose": "เลือกโหนด",
  "node.breadcrumb": "เส้นทางไปยังโหนดนี้",
  "node.search": "ค้นหาโหนด",
  "node.searchPlaceholder": "ชื่อหรือรหัสโบรกเกอร์",
  "node.results": "ผลการค้นหา",
  "node.noResults": "ไม่พบโหนดที่ตรงกันในขอบเขตของคุณ",
  "node.memberships": "สมาชิกภาพของคุณ",
  "node.noMemberships": "ไม่มีสมาชิกภาพที่ใช้งานอยู่",
  "node.children": "โหนดลูกโดยตรง",
  "node.noChildren": "โหนดนี้ไม่มีโหนดลูก",
  "node.childCount": "โหนดลูก {count} โหนด",
  "node.selectorAria": "โหนดที่เลือก: {name} เลือกโหนดอื่น",
  "node.loadFailed": "โหลดรายการโหนดไม่สำเร็จ",
  "header.node": "โหนด: {name}",
  "header.currency": "ตัวเลขเป็นสกุล",
  "shell.signedInAs": "เข้าสู่ระบบในชื่อ {email}",
  "shell.notStaff.eyebrow": "พอร์ทัลโบรกเกอร์",
  "shell.notStaff.title": "บัญชีนี้ไม่ใช่พนักงานโบรกเกอร์",
  "shell.notStaff.body": "คุณเข้าสู่ระบบแล้ว แต่ไม่มีสมาชิกภาพในโบรกเกอร์ใด โปรดขอให้เจ้าของหรือผู้ดูแลโบรกเกอร์เชิญคุณ แล้วเข้าสู่ระบบอีกครั้ง",
  "shell.noActive.eyebrow": "พอร์ทัลโบรกเกอร์",
  "shell.noActive.invitedTitle": "คุณได้รับคำเชิญ",
  "shell.noActive.invitedBody": "ยอมรับคำเชิญเพื่อเปิดพอร์ทัลของโบรกเกอร์นั้น การปฏิเสธต้องระบุเหตุผล ซึ่งจะถูกบันทึกไว้",
  "shell.noActive.suspendedTitle": "สิทธิ์เข้าถึงโบรกเกอร์ของคุณถูกระงับ",
  "shell.noActive.suspendedBody": "สมาชิกภาพทั้งหมดของคุณถูกระงับ เจ้าของหรือผู้ดูแลโบรกเกอร์สามารถเปิดใช้งานอีกครั้งได้",
  "shell.noActive.suspendedCount": "สมาชิกภาพที่ถูกระงับ {count} รายการ",
  "shell.nodeError.eyebrow": "พอร์ทัลโบรกเกอร์",
  "shell.nodeError.title": "โหนดนี้อยู่นอกขอบเขตของคุณ",
  "shell.nodeError.body": "ลิงก์นี้ระบุโหนด {id} ซึ่งสมาชิกภาพของคุณไม่ครอบคลุม หรือโหนดนี้ไม่มีอยู่ คำตอบจากเซิร์ฟเวอร์แสดงอยู่ด้านล่าง",
  "shell.nodeError.home": "ไปที่โหนดของคุณ",
  "shell.error.title": "พอร์ทัลโหลดสมาชิกภาพของคุณไม่สำเร็จ",

  "invitations.title": "คำเชิญ",
  "invitations.subtitle": "สมาชิกภาพบนโหนดอื่นที่คุณได้รับเชิญ",
  "invitations.pending": "คำเชิญที่รอดำเนินการ",
  "invitations.none": "ไม่มีคำเชิญที่รอดำเนินการ",
  "invitations.banner": "คุณมีคำเชิญไปยังโหนดอื่นที่รอดำเนินการ {count} รายการ",
  "invitations.review": "ตรวจสอบ",
  "invitations.line": "{role} บน {id}",
  "invitations.invitedAt": "เชิญเมื่อ",
  "invitations.accept": "ยอมรับ",
  "invitations.decline": "ปฏิเสธ",
  "invitations.acceptTitle": "ยอมรับคำเชิญไปยัง {name} หรือไม่",
  "invitations.acceptBody": "คุณจะเข้าร่วมในบทบาท {role} และมีผลทันที",
  "invitations.declineTitle": "ปฏิเสธคำเชิญไปยัง {name} หรือไม่",
  "invitations.declineBody": "คำเชิญจะถูกนำออก หากต้องการเข้าร่วมภายหลังต้องได้รับคำเชิญใหม่",

  "login.brand": "Smart Market · พอร์ทัลโบรกเกอร์",
  "login.eyebrow": "พนักงานโบรกเกอร์",
  "login.signIn": "เข้าสู่ระบบพอร์ทัลโบรกเกอร์",
  "login.subtitle": "ใช้อีเมลที่โบรกเกอร์ของคุณเชิญ สิ่งที่คุณเห็นขึ้นอยู่กับสมาชิกภาพของคุณ",
  "login.email": "อีเมล",
  "login.password": "รหัสผ่าน",
  "login.continue": "ดำเนินการต่อ",
  "login.signingIn": "กำลังเข้าสู่ระบบ…",
  "login.twoFactor": "การยืนยันตัวตนสองขั้นตอน",
  "login.enterCode": "กรอกรหัสของคุณ",
  "login.codeInstruction": "กรอกรหัส 6 หลักจากแอปยืนยันตัวตนสำหรับ {email}",
  "login.digitAria": "หลักที่ {digit}",
  "login.verify": "ยืนยัน",
  "login.verifying": "กำลังยืนยัน…",
  "login.back": "กลับไปหน้าเข้าสู่ระบบ",
  "login.error.credentials": "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
  "login.error.codeRejected": "รหัสไม่ถูกต้อง โปรดใช้รหัสปัจจุบัน",
  "login.error.rateLimit": "พยายามหลายครั้งเกินไป โปรดรอสักครู่แล้วลองอีกครั้ง",
  "login.error.unreachable": "เชื่อมต่อบริการเข้าสู่ระบบไม่ได้",
  "login.error.verify": "ยืนยันรหัสไม่สำเร็จ",
  "login.error.signIn": "เข้าสู่ระบบไม่สำเร็จ",
  "login.error.noFactor": "บัญชีนี้ต้องใช้การยืนยันขั้นที่สอง แต่ยังไม่ได้ตั้งค่า",
  "login.reason.expired": "เซสชันของคุณสิ้นสุดแล้ว โปรดเข้าสู่ระบบอีกครั้ง",
  "login.reason.signed-out": "คุณออกจากระบบแล้ว",
  "login.reason.revoked": "สิทธิ์เข้าถึงโบรกเกอร์ของคุณถูกนำออกหรือถูกระงับ ระบบจึงนำคุณออกจากระบบ",
  "login.forgot": "ลืมรหัสผ่าน?",
  "forgot.title": "รีเซ็ตรหัสผ่าน",
  "forgot.subtitle": "กรอกอีเมลที่คุณใช้เข้าสู่ระบบพอร์ทัลโบรกเกอร์ เราจะส่งลิงก์สำหรับตั้งรหัสผ่านใหม่ไปให้",
  "forgot.submit": "ส่งลิงก์ไปที่อีเมล",
  "forgot.sent": "หากอีเมลนี้มีบัญชีเข้าสู่ระบบพอร์ทัลโบรกเกอร์ เราได้ส่งลิงก์ไปให้แล้ว ลิงก์ใช้ได้ครั้งเดียวและหมดอายุใน 1 ชั่วโมง",
  "password.set.title": "ตั้งรหัสผ่าน",
  "password.set.subtitle": "ตั้งรหัสผ่านสำหรับเข้าสู่ระบบพอร์ทัลโบรกเกอร์ แล้วระบบจะพาคุณเข้าสู่ระบบทันที",
  "password.set.submit": "ตั้งรหัสผ่านและเข้าสู่ระบบ",
  "password.reset.title": "ตั้งรหัสผ่านใหม่",
  "password.reset.subtitle": "รหัสผ่านใหม่จะใช้แทนรหัสเดิม และระบบจะออกจากระบบบนอุปกรณ์อื่นทั้งหมด",
  "password.reset.submit": "บันทึกรหัสผ่านใหม่",
  "password.new": "รหัสผ่านใหม่",
  "password.confirm": "ยืนยันรหัสผ่านใหม่",
  "password.rule": "อย่างน้อย {min} ตัวอักษร",
  "password.tooShort": "ใช้อย่างน้อย {min} ตัวอักษร",
  "password.mismatch": "รหัสผ่านทั้งสองช่องไม่ตรงกัน",
  "password.saving": "กำลังบันทึก…",
  "password.error.failed": "บันทึกรหัสผ่านไม่สำเร็จ โปรดลองอีกครั้ง",
  "password.expired.title": "ลิงก์นี้หมดอายุแล้ว",
  "password.expired.set": "ลิงก์นี้หมดอายุหรือถูกใช้ไปแล้ว โปรดขอให้ผู้ที่เชิญคุณส่งลิงก์ใหม่",
  "password.expired.reset": "ลิงก์นี้หมดอายุหรือถูกใช้ไปแล้ว โปรดขอลิงก์ใหม่",
  "password.expired.requestNew": "ขอลิงก์ใหม่",

  "audit.recorded": "เสร็จสิ้น บันทึกไว้ในประวัติการตรวจสอบแล้ว",
  "audit.reference": "เลขอ้างอิงการตรวจสอบ:",
  "audit.referenceMissing": "เซิร์ฟเวอร์ไม่ได้ส่งเลขอ้างอิงการตรวจสอบของรายการนี้",

  "overview.title": "ภาพรวม",
  "overview.subtitle": "หกแผงจากการอ่านข้อมูลครั้งเดียว แต่ละแผงแจ้งว่าแหล่งข้อมูลตอบกลับหรือไม่",
  "overview.descendantCount": "โหนดลูกหลานในขอบเขต {count} โหนด",
  "overview.leaf": "ไม่มีโหนดลูกหลาน",
  "overview.generatedAt": "สร้างเมื่อ",
  "overview.panel.earnings": "รายได้ที่ได้รับ",
  "overview.panel.revenue": "สถานะรายได้",
  "overview.panel.funding": "เงินทุน",
  "overview.panel.exposure": "ความเสี่ยง",
  "overview.panel.activity": "กิจกรรม",
  "overview.panel.attention": "ต้องดำเนินการ",
  "overview.empty.earnings": "ยังไม่มีรายได้ในสกุลเงินนี้",
  "overview.empty.revenue": "ยังไม่มีรายได้ในสกุลเงินนี้",
  "overview.empty.funding": "ไม่มีพูลในสกุลเงินนี้",
  "overview.empty.exposure": "ไม่มีความเสี่ยง: ความเสี่ยงมีเฉพาะบัญชีเครดิตจากบุคคลที่สามในสกุล GOLD",
  "overview.empty.activity": "ไม่มีกิจกรรมในสกุลเงินนี้ในรอบนี้",
  "overview.empty.attention": "ไม่มีรายการที่ต้องดำเนินการ",
  "overview.forbidden": "บทบาทของคุณดูแผงนี้ไม่ได้ (ต้องมีสิทธิ์ดูข้อมูลการเงิน)",
  "overview.unavailable": "แหล่งข้อมูลไม่ตอบกลับ ระบบไม่แสดงตัวเลขแทนการแสดงตัวเลขที่ผิด",
  "overview.unknownState": "แผงนี้รายงานสถานะที่พอร์ทัลไม่รู้จัก: {state}",
  "overview.stale": "ข้อมูลเก่า",
  "overview.asOf": "แหล่งข้อมูลตอบเมื่อ",
  "overview.openDetail": "เปิด {screen}",
  "overview.figure": "รายการ",
  "overview.own": "โหนดนี้",
  "overview.descendants": "โหนดลูกหลาน",
  "overview.total": "รวม",
  "overview.totalSub": "โหนดนี้ + โหนดลูกหลาน",
  "overview.earnings.allTime": "ค่าธรรมเนียมทั้งหมด",
  "overview.earnings.today": "ค่าธรรมเนียมวันนี้",
  "overview.earnings.period": "ค่าธรรมเนียมรอบนี้",
  "overview.earnings.previous": "ค่าธรรมเนียมรอบก่อน",
  "overview.earnings.window": "รอบปัจจุบัน",
  "overview.activity.activeAccounts": "บัญชีที่ใช้งานอยู่",
  "overview.activity.openOrders": "คำสั่งที่เปิดอยู่",
  "overview.activity.openPositions": "สถานะที่เปิดอยู่",
  "overview.activity.fills": "รายการจับคู่ในรอบนี้",
  "overview.activity.tradedValue": "มูลค่าการซื้อขายในรอบนี้",
  "overview.activity.partial": "ตัวเลขบางรายการหายไปเพราะแหล่งข้อมูลไม่ตอบกลับ ({code})",
  "overview.activity.figureUnavailable": "ไม่พร้อมใช้งาน",
  "overview.attention.none": "ไม่มีรายการที่ต้องดำเนินการ",
  "attention.RECON_FINDINGS": "ข้อสังเกตจากการกระทบยอด {count} รายการ",
  "attention.FAILED_PAYOUTS": "ชุดการจ่ายเงินที่ล้มเหลว {count} ชุด",
  "attention.PAUSED_ACCOUNTS": "บัญชีผู้ใช้ที่ถูกระงับ {count} บัญชี",
  "attention.PAUSED_NODES": "โหนดที่พักการทำงาน {count} โหนด",
  "attention.PENDING_INVITATIONS": "คำเชิญพนักงานที่รอดำเนินการ {count} รายการ",
  "attention.EXPOSURE_WARNING": "ความเสี่ยงใกล้หรือเกินวงเงิน",

  "org.title": "องค์กร",
  "org.subtitle": "โปรไฟล์ การตั้งค่าธุรกิจ และสถานะวงจรชีวิต ดูได้อย่างเดียวในพอร์ทัล ยกเว้นรูปสกุลเงิน",
  "org.status.title": "สถานะวงจรชีวิต",
  "org.status.own": "สถานะของโหนด",
  "org.status.effective": "สถานะที่มีผล",
  "org.status.restricted": "โหนดที่อยู่เหนือขึ้นไปจำกัดโหนดนี้ สถานะที่มีผลจึงไม่ใช่สถานะของโหนดเอง",
  "org.status.reason": "เหตุผล: {reason}",
  "org.status.changedAt": "เปลี่ยนเมื่อ",
  "org.exchangeOperated": "การเปลี่ยนโปรไฟล์ การตั้งค่า และวงจรชีวิตทำโดยตลาด โปรดติดต่อตลาดเพื่อขอเปลี่ยนแปลง",
  "org.profile.title": "โปรไฟล์",
  "org.profile.displayName": "ชื่อที่แสดง",
  "org.profile.legalName": "ชื่อนิติบุคคล",
  "org.profile.brokerId": "รหัสโบรกเกอร์",
  "org.profile.parent": "โหนดแม่",
  "org.profile.isRoot": "ไม่มี นี่คือโบรกเกอร์ราก",
  "org.profile.root": "โบรกเกอร์ราก",
  "org.profile.depth": "ระดับความลึก",
  "org.profile.settingsVersion": "เวอร์ชันการตั้งค่า",
  "org.profile.hierarchyVersion": "เวอร์ชันลำดับชั้น",
  "org.profile.created": "สร้างเมื่อ",
  "org.profile.updated": "อัปเดตเมื่อ",
  "org.contacts": "ผู้ติดต่อ",
  "org.noContacts": "ไม่มีข้อมูลผู้ติดต่อ",
  "org.settings": "การตั้งค่าธุรกิจ",
  "org.noSettings": "ไม่มีการตั้งค่าธุรกิจ",
  "org.audit.title": "ประวัติการตรวจสอบ",
  "org.audit.empty": "ยังไม่มีเหตุการณ์ในประวัติการตรวจสอบ",
  "org.audit.action": "การกระทำ",
  "org.audit.entity": "รายการ",
  "org.audit.actor": "ผู้กระทำ",
  "org.audit.event": "เหตุการณ์",
  "org.image.title": "รูปสกุลเงิน (GOLD)",
  "org.image.intro": "รูปเหรียญที่ผู้ใช้ของคุณเห็นข้างยอดเงิน GOLD ทุกจุดบนเว็บไซต์ เปลี่ยนได้เฉพาะรูปเท่านั้น ชื่อ สัญลักษณ์ และทศนิยมยังเป็นของแพลตฟอร์ม",
  "org.image.source": "ที่ผู้ใช้ของคุณเห็น",
  "org.image.source.own": "รูปของคุณ",
  "org.image.source.parent": "จากโบรกเกอร์ต้นสังกัด {name}",
  "org.image.source.parentHidden": "จากโบรกเกอร์ต้นสังกัด",
  "org.image.source.default": "Gold (ค่าเริ่มต้นของแพลตฟอร์ม)",
  "org.image.sample": "ตัวอย่างยอดเงิน",
  "org.image.changedAt": "เปลี่ยนล่าสุด",
  "org.image.changedBy": "เปลี่ยนโดย",
  "org.image.upload": "อัปโหลดรูป",
  "org.image.replace": "เปลี่ยนรูป",
  "org.image.remove": "ลบรูป",
  "org.image.hint": "ใช้รูปสี่เหลี่ยมจัตุรัส อย่างน้อย 128 × 128 รูปจะแสดงขนาดเล็กข้างยอดเงินทุกจุด",
  "org.image.types": "PNG, JPEG, WebP หรือ SVG ขนาดไม่เกิน 10 MB",
  "org.image.preview": "ดูตัวอย่างก่อนบันทึก",
  "org.image.previewSize": "{px} px",
  "org.image.save": "บันทึกรูป",
  "org.image.saved": "บันทึกแล้ว ผู้ใช้ของคุณจะเห็นรูปใหม่ภายใน 5 นาที หรือเมื่อโหลดหน้าใหม่",
  "org.image.removeTitle": "ลบรูปสกุลเงินใช่หรือไม่",
  "org.image.removeToParent": "ผู้ใช้ของคุณจะเห็นรูปของ {name}",
  "org.image.removeToParentHidden": "ผู้ใช้ของคุณจะเห็นรูปของโบรกเกอร์ต้นสังกัด",
  "org.image.removeToGold": "ผู้ใช้ของคุณจะเห็นเหรียญ Gold",
  "org.image.lock.system": "ผู้ใช้ของ SYSTEM_BROKER เห็นเหรียญ Gold ของแพลตฟอร์มเสมอ จึงเปลี่ยนรูปนี้ไม่ได้",
  "org.image.lock.closed": "โบรกเกอร์นี้ปิดแล้ว จึงเปลี่ยนรูปสกุลเงินไม่ได้อีก",
  "org.image.readOnly": "เฉพาะเจ้าของหรือผู้ดูแลของโบรกเกอร์นี้ หรือของโบรกเกอร์ที่อยู่เหนือขึ้นไป จึงจะเปลี่ยนรูปนี้ได้",
  "org.image.err.tooLarge": "ไฟล์นี้ใหญ่เกินไป เลือกรูปที่มีขนาดไม่เกิน 10 MB",
  "org.image.err.type": "ไฟล์นี้ไม่ใช่รูปที่รองรับ เลือกไฟล์ PNG, JPEG, WebP หรือ SVG",

  "staff.title": "พนักงาน",
  "staff.subtitle": "สมาชิกของโหนดนี้และบทบาท",
  "staff.members": "สมาชิก",
  "staff.includeRemoved": "รวมผู้ที่ถูกนำออก",
  "staff.empty": "ไม่มีพนักงานบนโหนดนี้",
  "staff.readOnly": "คุณดูพนักงานของโหนดนี้ได้ การจัดการต้องมีสมาชิกภาพระดับเจ้าของหรือผู้ดูแลบนโหนดนี้หรือโบรกเกอร์ที่อยู่เหนือโหนดนี้",
  "staff.user": "ผู้ใช้",
  "staff.role": "บทบาท",
  "staff.invited": "เชิญเมื่อ",
  "staff.activated": "เปิดใช้งานเมื่อ",
  "staff.by": "โดย {id}",
  "staff.byExchange": "โดยตลาด",
  "staff.you": "คุณ",
  "staff.invite": "เชิญ",
  "staff.inviteTitle": "เชิญพนักงาน",
  "staff.inviteBody": "เราจะส่งลิงก์ไปที่อีเมลของบุคคลนี้ และผู้ได้รับเชิญจะยอมรับคำเชิญเองหลังเข้าสู่ระบบ",
  "staff.roleHint": "คุณให้บทบาทได้ไม่เกินบทบาทของคุณเอง เซิร์ฟเวอร์จะปฏิเสธบทบาทที่สูงกว่า",
  "staff.changeRole": "เปลี่ยนบทบาท",
  "staff.roleTitle": "เปลี่ยนบทบาทของ {user}",
  "staff.roleBody": "บทบาทปัจจุบัน: {role}",
  "staff.newRole": "บทบาทใหม่",
  "staff.cmd.suspend.title": "ระงับ {user} หรือไม่",
  "staff.cmd.suspend.body": "สมาชิกจะเสียสิทธิ์เข้าถึงตั้งแต่คำขอถัดไปจนกว่าจะเปิดใช้งานอีกครั้ง",
  "staff.cmd.suspend.confirm": "ระงับ",
  "staff.cmd.resume.title": "เปิดใช้งาน {user} อีกครั้งหรือไม่",
  "staff.cmd.resume.body": "สมาชิกจะได้สิทธิ์ตามบทบาทกลับคืน",
  "staff.cmd.resume.confirm": "เปิดใช้งานอีกครั้ง",
  "staff.cmd.remove.title": "นำ {user} ออกหรือไม่",
  "staff.cmd.remove.body": "การนำออกเป็นการถาวร หากต้องการเพิ่มอีกครั้งต้องส่งคำเชิญใหม่",
  "staff.cmd.remove.confirm": "นำออก",
  "staff.coverage": "ขอบเขต",
  "staff.thisNode": "โหนดนี้",
  "staff.includeSubBrokers": "รวมโบรกเกอร์ย่อย",
  "staff.coverageSubtree": "โหนดนี้และโบรกเกอร์ย่อย",
  "staff.emptySubtree": "ยังไม่มีพนักงานบนโหนดนี้หรือโบรกเกอร์ย่อย",
  "staff.node": "โหนด",
  "staff.openNode": "เปิดโหนดนี้",
  "staff.filterUser": "แสดงโหนดที่บุคคลนี้เข้าถึงได้",
  "staff.dates": "เชิญ / เปิดใช้งาน",
  "staff.accessFor": "สิทธิ์เข้าถึงของ",
  "staff.addNodeAccess": "เพิ่มสิทธิ์เข้าถึงโหนด",
  "staff.clearFilter": "ล้าง",
  "staff.assignedByParent": "มอบหมายโดยโบรกเกอร์แม่",
  "staff.assignedByParentHint": "โบรกเกอร์ที่อยู่เหนือโหนดนี้เป็นผู้เพิ่มสมาชิกคนนี้ เจ้าของและผู้ดูแลของโหนดนี้ยังเปลี่ยนบทบาทหรือนำออกได้",
  "staff.inviteSubtreeBody": "เราจะส่งลิงก์ไปที่อีเมลของบุคคลนี้ให้ตั้งรหัสผ่านและเข้าสู่ระบบพอร์ทัลโบรกเกอร์ บุคคลนี้จะเข้าถึงโหนดที่เลือกแต่ละโหนดและทุกโหนดที่อยู่ใต้โหนดนั้น ไม่เห็นโหนดที่อยู่เหนือหรือข้างเคียง และต้องยอมรับคำเชิญแต่ละรายการเอง",
  "staff.inviteReasonHint": "บันทึกไว้ในประวัติการตรวจสอบของแต่ละโหนดที่เลือก",
  "staff.roleHintOwner": "ในฐานะเจ้าของ คุณให้บทบาทใดก็ได้",
  "staff.roleHintAdmin": "ในฐานะผู้ดูแล คุณให้บทบาทการเงิน เทรดเดอร์ และผู้ดูได้",
  "staff.selfInvite": "คุณเชิญตัวเองไม่ได้ โปรดให้เจ้าของหรือผู้ดูแลคนอื่นเป็นผู้เชิญ",
  "staff.nodes": "โหนด",
  "staff.nodesSearch": "ค้นหาโหนดตามชื่อหรือรหัส",
  "staff.nodesNone": "ไม่มีโหนดที่ตรงกัน",
  "staff.nodesHint": "บุคคลนี้จะเข้าถึงโหนดที่เลือกแต่ละโหนดและทุกโหนดที่อยู่ใต้โหนดนั้น โดยจะไม่เห็นโหนดที่อยู่เหนือหรือข้างเคียง",
  "staff.nodesSelected": "โหนดที่เลือก: {count}",
  "staff.inviteToNodes": "เชิญเข้า {count} โหนด",
  "staff.inviteResultTitle": "ผลการเชิญ",
  "staff.inviteResultBody": "ส่งคำเชิญสำเร็จ {ok} จาก {total} รายการ",
  "staff.inviteState.pending": "กำลังส่ง",
  "staff.inviteState.ok": "เชิญแล้ว",
  "staff.inviteState.failed": "ไม่สำเร็จ",
  "staff.retryFailed": "ลองใหม่เฉพาะที่ไม่สำเร็จ ({count})",
  "staff.email": "อีเมล",
  "staff.emailPlaceholder": "name@company.com",
  "staff.emailHint": "เราจะส่งลิงก์ไปที่อีเมลนี้ให้ตั้งรหัสผ่านและเข้าสู่ระบบพอร์ทัลโบรกเกอร์ คำเชิญจะยังไม่ให้สิทธิ์ใดจนกว่าผู้รับจะยอมรับ",
  "staff.emailInvalid": "กรอกอีเมลให้ถูกต้อง เช่น name@company.com",
  "staff.pendingSignUp": "รอตั้งรหัสผ่าน",
  "staff.pendingSignUpHint": "ได้รับเชิญแล้วแต่ยังไม่ได้ตั้งรหัสผ่าน คุณส่งอีเมลคำเชิญอีกครั้งได้",
  "staff.technicalDetails": "รายละเอียดทางเทคนิค",
  "staff.staffId": "รหัสพนักงาน",
  "staff.resend.title": "ส่งคำเชิญถึง {user} อีกครั้งหรือไม่?",
  "staff.resend.body": "เราจะส่งลิงก์ตั้งรหัสผ่านใหม่ไปที่ {email} และลิงก์ในอีเมลก่อนหน้าจะใช้ไม่ได้อีก",
  "staff.resend.confirm": "ส่งคำเชิญอีกครั้ง",
  "security.title": "ความปลอดภัย",
  "security.subtitle": "การเข้าสู่ระบบพอร์ทัลโบรกเกอร์ของคุณ: รหัสผ่านและแอปยืนยันตัวตน",
  "security.clientMode": "คุณเข้าสู่ระบบพอร์ทัลโบรกเกอร์ด้วยบัญชีของเว็บไซต์เทรด โปรดเปลี่ยนรหัสผ่านและการยืนยันสองขั้นตอนที่นั่น",
  "security.account": "การเข้าสู่ระบบของคุณ",
  "security.name": "ชื่อ",
  "security.passwordChanged": "เปลี่ยนรหัสผ่านล่าสุด",
  "security.changePassword": "เปลี่ยนรหัสผ่าน",
  "security.currentPassword": "รหัสผ่านปัจจุบัน",
  "security.changePasswordHint": "เมื่อเปลี่ยนรหัสผ่าน ระบบจะออกจากระบบบนอุปกรณ์อื่นทั้งหมด",
  "security.passwordChangedDone": "เปลี่ยนรหัสผ่านแล้ว และออกจากระบบบนอุปกรณ์อื่นแล้ว",
  "security.authenticator": "แอปยืนยันตัวตน",
  "security.totpOn": "เปิด",
  "security.totpOff": "ปิด",
  "security.totpOffBody": "เพิ่มขั้นตอนที่สองในการเข้าสู่ระบบ: หลังกรอกรหัสผ่าน ให้กรอกรหัส 6 หลักจากแอปยืนยันตัวตนบนโทรศัพท์",
  "security.totpSetUp": "ตั้งค่าแอปยืนยันตัวตน",
  "security.qrAria": "คิวอาร์โค้ดสำหรับสแกนด้วยแอปยืนยันตัวตน",
  "security.totpStep1": "เปิดแอปยืนยันตัวตน (Google Authenticator, Microsoft Authenticator, 1Password…) แล้วสแกนคิวอาร์โค้ดนี้",
  "security.totpStep2": "กรอกรหัส 6 หลักที่แอปแสดงเพื่อเสร็จสิ้น",
  "security.totpManual": "สแกนไม่ได้? กรอกคีย์นี้ในแอป:",
  "security.code": "รหัส 6 หลัก",
  "security.totpConfirm": "เปิดใช้งาน",
  "security.totpOnDone": "เปิดแอปยืนยันตัวตนแล้ว คุณจะต้องกรอกรหัสจากแอปทุกครั้งที่เข้าสู่ระบบ",
  "security.totpOnBody": "คุณต้องกรอกรหัสจากแอปยืนยันตัวตนทุกครั้งที่เข้าสู่ระบบ หากต้องการนำออก ให้กรอกรหัสปัจจุบัน",
  "security.totpRemove": "นำแอปยืนยันตัวตนออก",
  "security.totpOffDone": "นำแอปยืนยันตัวตนออกแล้ว คุณจะเข้าสู่ระบบด้วยรหัสผ่านเท่านั้น",
  "security.totpFailed": "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
  "child.open": "สร้างโบรกเกอร์ย่อย",
  "child.title": "สร้างโบรกเกอร์ย่อย",
  "child.body": "โหนดใหม่จะถูกสร้างภายใต้ {parent} ในสถานะฉบับร่าง",
  "child.displayName": "ชื่อที่แสดง",
  "child.legalName": "ชื่อนิติบุคคล",
  "child.draftNote": "โหนดฉบับร่างยังทำอะไรไม่ได้จนกว่าตลาดจะอนุมัติ ไม่มีผู้ใช้ เงินทุน หรือคำสั่งซื้อขาย",
  "child.create": "สร้างฉบับร่าง",
  "child.keyConflict": "แบบฟอร์มนี้ถูกส่งไปแล้วด้วยรายละเอียดอื่น ปิดแบบฟอร์มแล้วเริ่มใหม่",

  "hierarchy.title": "ลำดับชั้น",
  "hierarchy.subtitle": "โหนดภายใต้โหนดที่เลือก เปิดแถวใดก็ได้เพื่อเลือกเป็นโหนดปัจจุบัน",
  "hierarchy.search": "ค้นหาโหนด",
  "hierarchy.searchLabel": "ค้นหาในลำดับชั้นย่อยนี้",
  "hierarchy.tree": "ภายใต้ {name}",
  "hierarchy.treeAria": "แผนผังโหนด",
  "hierarchy.noChildren": "โหนดนี้ไม่มีโหนดลูก",
  "hierarchy.noChildrenBelow": "ไม่มีโหนดลูก",
  "hierarchy.loadMore": "โหลดเพิ่ม ({shown} จาก {total})",
  "hierarchy.expand": "ขยาย {name}",
  "hierarchy.collapse": "ย่อ {name}",
  "hierarchy.effective": "มีผลเป็น {status}",
  "hierarchy.effectiveHint": "โหนดที่อยู่เหนือขึ้นไปจำกัดโหนดนี้",
  "hierarchy.open": "เปิด",

  "users.title": "ผู้ใช้",
  "users.subtitle": "บัญชีโบรกเกอร์ที่โหนดนี้และโหนดลูกหลานให้บริการ เลือกขอบเขตเพื่อดูเฉพาะของโหนดนี้",
  "users.filters": "ตัวกรอง",
  "users.scope": "ขอบเขต",
  "users.scopeDirect": "ให้บริการโดยตรง",
  "users.scopeSubtree": "ทั้งลำดับชั้นย่อย",
  "users.balanceMode": "รูปแบบยอดเงิน",
  "users.search": "ค้นหา",
  "users.searchPlaceholder": "ขึ้นต้นรหัสผู้ใช้หรือรหัสบัญชี",
  "users.accounts": "บัญชี",
  "users.empty": "ไม่พบบัญชีที่ตรงกัน",
  "users.account": "บัญชี",
  "users.user": "ผู้ใช้",
  "users.servicingNode": "โหนดที่ให้บริการ",
  "users.thisNode": "โหนดนี้",
  "users.created": "สร้างเมื่อ",
  "users.updated": "อัปเดตเมื่อ",
  "users.details": "รายละเอียด",
  "users.detailTitle": "ผู้ใช้",
  "users.accountCard": "บัญชี",
  "users.openInNewTab": "เปิดบัญชี {id} ในแท็บใหม่",
  "users.brokerEffective": "สถานะโบรกเกอร์ที่ให้บริการ",
  "users.entryPath": "ช่องทางที่สร้าง",
  "users.statusReason": "เหตุผลของสถานะ",
  "users.tabs": "กิจกรรมของบัญชี",
  "users.tab.orders": "คำสั่งที่เปิดอยู่",
  "users.tab.positions": "สถานะการถือครองปัจจุบัน",
  "users.tab.history": "ประวัติคำสั่งซื้อขาย",
  "users.tab.trades": "ประวัติการซื้อขาย",
  "users.eventsTitle": "ประวัติ",
  "users.noEvents": "ยังไม่มีประวัติ",
  "users.eventActor": "โดย {kind} {id}",
  "users.eventActorExchange": "โดยตลาด",
  "users.eventReason": "เหตุผล: {reason}",
  "users.closedNote": "บัญชีนี้ปิดแล้ว การปิดบัญชีเป็นการดำเนินการของตลาดและย้อนกลับที่นี่ไม่ได้",
  "users.pauseNeedsRole": "การพักบัญชีต้องมีสมาชิกภาพเจ้าของหรือผู้ดูแลบนโหนดที่ให้บริการบัญชีนั้น",
  "users.pauseDirectOnly": "เฉพาะโหนดที่ให้บริการบัญชีนี้โดยตรงเท่านั้นที่พักบัญชีได้",
  "users.pauseNote": "การพักบัญชีไม่ปิดบัญชีและไม่แตะต้องยอดเงิน",
  "users.cmd.suspend.title": "ระงับบัญชี {id} หรือไม่",
  "users.cmd.suspend.body": "ผู้ใช้จะซื้อขายผ่านบัญชีนี้ไม่ได้จนกว่าจะเปิดใช้งานอีกครั้ง สถานะที่เปิดอยู่และยอดเงินไม่เปลี่ยนแปลง",
  "users.cmd.suspend.confirm": "ระงับบัญชี",
  "users.cmd.resume.title": "เปิดใช้งานบัญชี {id} อีกครั้งหรือไม่",
  "users.cmd.resume.body": "ผู้ใช้จะใช้บัญชีนี้ได้อีกครั้ง",
  "users.cmd.resume.confirm": "เปิดใช้งานบัญชีอีกครั้ง",
  "users.loginLogTitle": "ประวัติการเข้าสู่ระบบ",
  "users.loginLogEmpty": "ยังไม่มีการเข้าสู่ระบบที่บันทึกไว้สำหรับบัญชีนี้",
  "users.loginLogHint": "แสดงการเข้าสู่ระบบระหว่างที่บัญชีนี้เปิดอยู่ จะไม่แสดงรายการใดเลยหากผู้ใช้มีบัญชีที่เปิดอยู่กับโบรกเกอร์นอกลำดับชั้นย่อยนี้ด้วย",
  "users.orderLogTitle": "ประวัติแหล่งที่มาของคำสั่งซื้อขาย",
  "users.orderLogEmpty": "ยังไม่มีคำสั่งซื้อขายสำหรับบัญชีนี้",
  "users.orderLogHint": "ไม่แสดงคำสั่งซื้อขายที่ส่งก่อนเริ่มระบุโบรกเกอร์",
  "users.orderLogUnrecordedNote": "เครื่องหมาย — ในช่อง IP อุปกรณ์ และช่องทาง หมายถึงไม่ได้บันทึกแหล่งที่มาของคำสั่งซื้อขายนั้น เช่น คำสั่งซื้อขายที่ส่งก่อนเปิดใช้การบันทึกแหล่งที่มา",
  "clientLog.time": "เวลา",
  "clientLog.method": "วิธีเข้าสู่ระบบ",
  "clientLog.ip": "IP",
  "clientLog.device": "อุปกรณ์",
  "clientLog.market": "ตลาด",
  "clientLog.side": "ฝั่ง",
  "clientLog.channel": "ช่องทาง",
  "device.label": "{browser} · {os} · {form}",
  "device.mobile": "มือถือ",
  "device.desktop": "เดสก์ท็อป",
  "device.unknownBrowser": "ไม่ทราบเบราว์เซอร์",
  "device.unknownOs": "ไม่ทราบระบบปฏิบัติการ",

  "positions.title": "สถานะการถือครอง",
  "positions.subtitle": "สถานะการถือครองของผู้ใช้ที่โหนดนี้และโหนดลูกหลานให้บริการ อ่านจากระบบชำระราคา",
  "positions.list": "สถานะการถือครอง",
  "positions.empty": "ไม่มีสถานะการถือครองในสกุลเงินนี้",
  "positions.market": "ตลาด",
  "positions.outcome": "ผลลัพธ์",
  "positions.account": "บัญชี",
  "positions.node": "โหนด {id}",
  "positions.quantity": "จำนวนหุ้น",
  "positions.avgPrice": "ราคาเฉลี่ย",
  "positions.realizedPnl": "กำไรขาดทุนที่เกิดขึ้นแล้ว",
  "positions.opened": "เปิดเมื่อ",
  "positions.emptyActive": "ไม่มีสถานะการถือครองปัจจุบันในสกุลเงินนี้",
  "positions.statusActive": "ปัจจุบัน (เปิดอยู่หรือแลกรับได้)",

  "orders.title": "คำสั่งที่เปิดอยู่",
  "orders.subtitle": "คำสั่งที่ยังทำงานอยู่ของผู้ใช้ที่โหนดนี้และโหนดลูกหลานให้บริการ ดูได้อย่างเดียว",
  "orderHistory.title": "ประวัติคำสั่งซื้อขาย",
  "orderHistory.subtitle": "หนึ่งแถวต่อคำสั่งที่สิ้นสุดแล้วหนึ่งรายการ: จับคู่ครบ ยกเลิก ถูกปฏิเสธ หมดอายุ หรือล้มเหลว",
  "trades.title": "ประวัติการซื้อขาย",
  "trades.subtitle": "หนึ่งแถวต่อการจับคู่หนึ่งฝั่ง พร้อมค่าธรรมเนียมและสถานะการบันทึกในบัญชีแยกประเภท",
  "orders.activeList": "คำสั่งที่เปิดอยู่",
  "orders.historyList": "ประวัติคำสั่งซื้อขาย",
  "orders.placed": "ส่งคำสั่งเมื่อ",
  "orders.finished": "สิ้นสุดเมื่อ",
  "orders.market": "ตลาด",
  "orders.outcome": "ผลลัพธ์",
  "orders.account": "บัญชี",
  "orders.side": "ฝั่ง",
  "orders.price": "ราคา",
  "orders.quantity": "จำนวน",
  "orders.filled": "จับคู่แล้ว",
  "orders.tif": "อายุคำสั่ง",
  "orders.reason": "เหตุผล",
  "orders.emptyActive": "ไม่มีคำสั่งที่เปิดอยู่ในสกุลเงินนี้",
  "orders.emptyHistory": "ไม่มีคำสั่งที่สิ้นสุดแล้วในสกุลเงินนี้",
  "trades.list": "ประวัติการซื้อขาย",
  "trades.time": "เวลา",
  "trades.liquidity": "เมกเกอร์ / เทกเกอร์",
  "trades.notional": "มูลค่าตามสัญญา",
  "trades.exchangeFee": "ค่าธรรมเนียมตลาด",
  "trades.brokerFee": "ค่าคอมมิชชันโบรกเกอร์",
  "trades.net": "ยอดสุทธิ",
  "trades.ledger": "บัญชีแยกประเภท",
  "trades.empty": "ไม่มีรายการซื้อขายในสกุลเงินนี้",
  "trades.gameSellsNote": "การขายในโหมด GAME ชำระเป็น GREEN",
  "trading.emptyHintAccount": "แสดงเฉพาะกิจกรรมในช่วงที่ผู้ใช้รายนี้อยู่ภายใต้โบรกเกอร์ของคุณ",
  "trading.emptyHintNode": "แสดงเฉพาะกิจกรรมในช่วงที่ผู้ใช้อยู่ภายใต้โบรกเกอร์ของคุณ",
  "trading.user": "ผู้ใช้",
  "trading.userResults": "บัญชีที่ตรงกัน",
  "trading.userSearchFailed": "ค้นหาบัญชีไม่สำเร็จ",
  "trading.userClear": "แสดงผู้ใช้ทั้งหมด",
  "trading.openAccount": "เปิดบัญชี {id} ในหน้าผู้ใช้ในแท็บใหม่",
  "trading.period": "ช่วงเวลา",
  "trading.lastDays": "{days} วันที่ผ่านมา",
  "trading.rangeTooLong": "เลือกได้ไม่เกิน {days} วัน",
  "trading.window": "ช่วงเวลา: {from} ถึง {to} รวมทั้งสองวัน เป็นวันเต็มตามเวลาท้องถิ่นของคุณ",

  "risk.title": "ความเสี่ยง",
  "risk.subtitle": "ความเสี่ยง หลักประกัน และวงเงิน ดูได้อย่างเดียว ตลาดเป็นผู้กำหนดวงเงิน",
  "risk.goldOnly": "แสดงเฉพาะ GOLD: ความเสี่ยงคือเครดิตจากบุคคลที่สาม ซึ่งมีเฉพาะในสกุล GOLD เท่านั้น",
  "risk.level.blocked": "ถูกบล็อก: ระบบปฏิเสธความเสี่ยงใหม่",
  "risk.level.warning": "คำเตือน: การใช้วงเงินถึงระดับเตือนแล้ว",
  "risk.level.ok": "อยู่ในวงเงิน",
  "risk.level.no-limit": "โหนดนี้ไม่มีวงเงินของตัวเอง ใช้วงเงินของโหนดที่อยู่เหนือขึ้นไปที่ใกล้ที่สุด",
  "risk.blocked": "ถูกบล็อก: ระบบปฏิเสธความเสี่ยงใหม่",
  "risk.warning": "ใกล้วงเงิน: การใช้วงเงินถึงหรือเกินระดับเตือน",
  "risk.blockedBecause": "เนื่องจาก: {reasons}",
  "risk.blockReason.HEADROOM_EXHAUSTED": "วงเงินคงเหลือหมด",
  "risk.blockReason.RECEIVABLE_OPEN": "มีลูกหนี้ค้างอยู่",
  "risk.blockReason.LIFECYCLE": "สถานะวงจรชีวิตของโหนด",
  "risk.ownExposure": "ความเสี่ยงของโหนด",
  "risk.ownExposureSub": "บัญชีที่โหนดนี้ให้บริการ",
  "risk.subtreeExposure": "ความเสี่ยงของลำดับชั้นย่อย",
  "risk.subtreeExposureSub": "โหนดนี้และโหนดลูกหลานทั้งหมด",
  "risk.openEntriesCount": "คำสั่งและสถานะที่เปิดอยู่ {count} รายการ",
  "risk.collateral": "หลักประกัน",
  "risk.collateralSub": "พูลทั้งหมดในลำดับชั้นย่อย",
  "risk.effectiveHeadroom": "วงเงินคงเหลือที่มีผล",
  "risk.bindingNode": "จำกัดโดย {name}",
  "risk.bindingSelf": "จำกัดโดยวงเงินของโหนดนี้เอง",
  "risk.bindingAbove": "จำกัดโดยโหนดที่อยู่เหนือขึ้นไปซึ่งคุณไม่มีสิทธิ์ดู",
  "risk.limitTitle": "วงเงิน",
  "risk.limit": "วงเงิน",
  "risk.headroom": "วงเงินคงเหลือ",
  "risk.allowance": "วงเงินเพิ่มเติม",
  "risk.allowanceExpires": "วงเงินเพิ่มเติมหมดอายุ",
  "risk.utilisation": "การใช้วงเงิน",
  "risk.utilisationOf": "ใช้ไป {used} · เตือนที่ {warn}",
  "risk.noOwnLimit": "ไม่มีวงเงินของตัวเอง",
  "risk.noOwnLimitBody": "โหนดนี้ไม่มีวงเงินของตัวเอง ใช้วงเงินคงเหลือที่น้อยที่สุดของโหนดที่มีวงเงินบนเส้นทาง (วงเงินคงเหลือที่มีผลด้านบน)",
  "risk.settlementTitle": "สถานะสุทธิและลูกหนี้",
  "risk.netPosition": "สถานะสุทธิ",
  "risk.owed": "ค้างชำระตลาด (ทั้งลำดับชั้น)",
  "risk.owedHint": "ยอดที่การซื้อขายในลำดับชั้นของคุณใช้ไปเกินกว่าที่ได้รับเครดิตคืน บันทึกการชำระและการชำระนอกแพลตฟอร์มไม่ลดยอดนี้ ลูกหนี้ที่ตลาดปิดว่าชำระแล้วหรือตัดเป็นหนี้สูญจะถูกหักในบรรทัดด้านล่างแทน",
  "risk.coveredByResolutions": "ลูกหนี้ที่ชำระแล้วหรือตัดเป็นหนี้สูญ",
  "risk.coveredByResolutionsHint": "ลูกหนี้ที่ตลาดปิดแล้ว เพราะชำระนอกแพลตฟอร์มหรือตัดเป็นหนี้สูญ",
  "risk.uncovered": "ยอดขาดหลักประกัน",
  "risk.uncoveredHint": "ยอดค้างชำระตลาด หักหลักประกันและลูกหนี้ที่ชำระแล้วหรือตัดเป็นหนี้สูญ ต่ำสุดคือ 0 โดย 0.00 หมายถึงหลักประกันครอบคลุมครบแล้ว หากมากกว่า 0 จะเปิดลูกหนี้และบล็อกคำสั่งใหม่",
  "risk.receivablesOpen": "ลูกหนี้ที่ค้างอยู่",
  "risk.netPositionNote": "สถานะสุทธิเป็นบวกหมายถึงตลาดค้างชำระโบรกเกอร์ ตัวเลขเป็นของโบรกเกอร์ราก",

  "fees.title": "ค่าธรรมเนียม",
  "fees.subtitle": "แผนค่าธรรมเนียมที่ใช้กับผู้ใช้ของโหนดนี้ และเครื่องคำนวณ",
  "fees.exchangeAuthored": "ตลาดหรือโบรกเกอร์รากของคุณเป็นผู้กำหนดแผนค่าธรรมเนียมและแผนแบ่งรายได้ หน้านี้แสดงแผนที่ใช้อยู่และคำนวณตัวอย่างด้วยเครื่องคำนวณของเซิร์ฟเวอร์",
  "fees.rootManages": "คุณจัดการแผนค่าธรรมเนียมและแผนแบ่งรายได้ของลำดับชั้นนี้ได้ที่โหนดราก {root} หน้านี้แสดงแผนที่ใช้อยู่ที่นี่",
  "fees.openPlanManagement": "เปิดหน้าจัดการแผน",
  "fees.noPlan": "ไม่มีแผนค่าธรรมเนียมที่ใช้กับโหนดนี้ในสกุล {currency}",
  "fees.noPlanHint": "คำสั่งซื้อขายของผู้ใช้ในโหนดนี้จะถูกปฏิเสธจนกว่าตลาดหรือโบรกเกอร์รากจะกำหนดแผน",
  "fees.assigned": "แผนที่กำหนด",
  "fees.plan": "แผน",
  "fees.active": "ใช้งานอยู่",
  "fees.retired": "เลิกใช้แล้ว",
  "fees.version": "เวอร์ชัน",
  "fees.versionN": "เวอร์ชัน {n}",
  "fees.currency": "สกุลเงิน",
  "fees.effective": "มีผลเมื่อ",
  "fees.assignment": "กำหนดที่ระดับ",
  "fees.assignmentTarget": "เป้าหมายของการกำหนด",
  "fees.assignedFrom": "กำหนดตั้งแต่",
  "fees.rates": "อัตรา",
  "fees.makerRate": "อัตราเมกเกอร์",
  "fees.takerRate": "อัตราเทกเกอร์",
  "fees.redemptionRate": "อัตราการแลกรับ",
  "fees.nodeShare": "ส่วนแบ่งค่าคอมมิชชันของโหนดนี้",
  "fees.shareVersion": "เวอร์ชันการแบ่งรายได้",
  "fees.planVersionId": "รหัสเวอร์ชันแผน",
  "fees.shareNote": "ส่วนแบ่งคือเวอร์ชันการแบ่งรายได้ที่จะถูกล็อกสำหรับคำสั่งใหม่ในขณะนี้ ส่วนการแลกรับจะใช้การแบ่งที่มีผลอยู่ ณ เวลาที่แลกรับ",
  "fees.defaultSplit": "การแบ่งเริ่มต้น: 100% ให้โบรกเกอร์ที่ให้บริการ",
  "fees.upcoming": "การเปลี่ยนแปลงที่กำหนดไว้",
  "fees.noUpcoming": "ไม่มีการเปลี่ยนแปลงที่กำหนดไว้",
  "fees.change": "การเปลี่ยนแปลง",
  "fees.upcomingAssignment": "การกำหนดใหม่ ({scope}) เป็นแผน {plan}",
  "fees.upcomingCleared": "ยกเลิกการกำหนด ({scope})",
  "fees.calc.tradeTitle": "เครื่องคำนวณค่าธรรมเนียมการซื้อขาย",
  "fees.calc.redemptionTitle": "เครื่องคำนวณค่าธรรมเนียมการแลกรับ",
  "fees.calc.redemptionGoldOnly": "ค่าธรรมเนียมการแลกรับใช้กับ GOLD เท่านั้น สกุลอื่นคิดเป็นศูนย์",
  "fees.calc.quantity": "จำนวน (หุ้น)",
  "fees.calc.quantityHint": "ทศนิยมได้ไม่เกิน 4 ตำแหน่ง",
  "fees.calc.price": "ราคา",
  "fees.calc.priceHint": "ระหว่าง 0 ถึง 1 เช่น 0.55",
  "fees.calc.role": "บทบาท",
  "fees.calc.market": "รหัสตลาด (ไม่บังคับ)",
  "fees.calc.marketHint": "หากระบุตลาด ระบบจะคำนวณส่วนของตลาดด้วย",
  "fees.calc.servicing": "โหนดที่ให้บริการ",
  "fees.calc.servicingHint": "โหนดของผู้ใช้ที่ซื้อขาย: โหนดนี้หรือโหนดลูกหลาน",
  "fees.calc.thisNode": "โหนดนี้ ({name})",
  "fees.calc.otherNode": "หรือรหัสของโหนดลูกหลานที่ลึกกว่า",
  "fees.calc.otherNodePlaceholder": "brk_…",
  "fees.calc.run": "คำนวณ",
  "fees.calc.inputError.empty": "กรอกค่า",
  "fees.calc.inputError.invalid": "กรอกตัวเลข",
  "fees.calc.inputError.tooPrecise": "ทศนิยมมากเกินไป",
  "fees.calc.inputError.notPositive": "ต้องมากกว่าศูนย์",
  "fees.calc.notional": "มูลค่าตามสัญญา",
  "fees.calc.feeBase": "ฐานค่าธรรมเนียม",
  "fees.calc.feeBaseSub": "จำนวน × ราคา × (1 − ราคา)",
  "fees.calc.exchangeFee": "ค่าธรรมเนียมตลาด",
  "fees.calc.exchangeNeedsMarket": "ระบุรหัสตลาดเพื่อคำนวณส่วนของตลาด",
  "fees.calc.brokerCommission": "ค่าคอมมิชชันโบรกเกอร์",
  "fees.calc.atRate": "ที่อัตรา {rate}",
  "fees.calc.totalUserFee": "ค่าธรรมเนียมรวมของผู้ใช้",
  "fees.calc.nodeShare": "ส่วนแบ่งของโหนดนี้",
  "fees.calc.shareOf": "{share} ของค่าคอมมิชชัน",
  "fees.calc.noShare": "โหนดนี้ไม่มีส่วนแบ่ง",
  "fees.calc.winningShares": "จำนวนหุ้นที่ชนะที่แลกรับ",
  "fees.calc.gross": "ยอดจ่ายก่อนหักค่าธรรมเนียม",
  "fees.calc.exchangeRedemptionFee": "ค่าธรรมเนียมการแลกรับของตลาด",
  "fees.calc.brokerRedemptionFee": "ค่าธรรมเนียมการแลกรับของโบรกเกอร์",
  "fees.calc.totalFee": "ค่าธรรมเนียมรวม",
  "fees.calc.netPayout": "ยอดจ่ายสุทธิ",
  "fees.calc.lockedPlan": "เวอร์ชันแผน",
  "fees.calc.feeOwner": "เจ้าของค่าธรรมเนียม",

  "authoring.when.label": "เริ่มมีผล",
  "authoring.when.now": "ทันที",
  "authoring.when.later": "ภายหลัง",
  "authoring.when.at": "วันที่และเวลา (เวลาท้องถิ่นของคุณ)",
  "authoring.when.localTime": "เริ่มมีผล {time} ตามเวลาท้องถิ่นของคุณ",
  "authoring.when.error.empty": "เลือกวันที่และเวลา",
  "authoring.when.error.invalid": "กรอกวันที่และเวลาที่ถูกต้อง",
  "authoring.when.error.past": "เลือกเวลาในอนาคต การเปลี่ยนแปลงย้อนหลังทำไม่ได้",
  "feePlans.title": "จัดการแผน",
  "feePlans.subtitle": "แผนค่าธรรมเนียมและแผนแบ่งรายได้ของทั้งลำดับชั้นภายใต้โบรกเกอร์รากนี้ เฉพาะเจ้าของและเจ้าหน้าที่การเงินของโบรกเกอร์รากเท่านั้นที่สร้างและแก้ไขได้ ทุกการเปลี่ยนแปลงมีเวอร์ชันและบันทึกไว้ในประวัติการตรวจสอบ",
  "feePlans.rootOnlyTitle": "การจัดการแผนอยู่ที่โหนดราก",
  "feePlans.rootOnlyBody": "แผนค่าธรรมเนียมและแผนแบ่งรายได้เป็นของโบรกเกอร์ราก {root} สิทธิ์จัดการแผนไม่ส่งต่อไปยังโหนดที่อยู่ใต้โหนดราก โปรดสลับไปที่โหนดรากเพื่อเปิดหน้าจัดการแผน",
  "feePlans.switchToRoot": "สลับไปที่ {root}",
  "feePlans.rulesTitle": "หลักการทำงานของแผนค่าธรรมเนียม",
  "feePlans.rule.currency": "แต่ละเวอร์ชันครอบคลุมสกุลเงินเดียว และลำดับชั้นของโบรกเกอร์ซื้อขายด้วย GOLD เท่านั้น เวอร์ชันใหม่จึงเผยแพร่เป็น GOLD ส่วนเวอร์ชัน RED หรือ GREEN ที่มีอยู่เดิมยังแสดงเป็นประวัติ โดยมีสถานะว่าไม่ได้ซื้อขาย",
  "feePlans.rule.immutable": "เวอร์ชันและการกำหนดที่เผยแพร่แล้วแก้ไขไม่ได้ การเปลี่ยนแปลงทำเป็นเวอร์ชันใหม่หรือการกำหนดใหม่ที่มีเวลาเริ่มมีผลของตัวเอง และการเปลี่ยนแปลงที่ตั้งเวลาไว้ไม่เปลี่ยนราคาของคำสั่งที่รับไปแล้ว",
  "feePlans.rule.ceiling": "อัตราเมกเกอร์รวมและอัตราเทกเกอร์รวม (ของตลาดบวกของโบรกเกอร์) แต่ละอัตราต้องไม่เกิน 100% ระบบตรวจสอบเมื่อรับคำสั่งซื้อขาย ไม่ใช่ตอนเผยแพร่ เวอร์ชันที่เกินเพดานจะทำให้คำสั่งที่ได้รับผลกระทบทั้งหมดล้มเหลว",
  "feePlans.rule.redemptionCeiling": "อัตราการแลกรับ GOLD ของโบรกเกอร์รวมกับอัตราการแลกรับสูงสุดของตลาดต้องไม่เกิน 100% ระบบตรวจสอบตอนเผยแพร่",
  "feePlans.rule.noFallback": "กฎค่าธรรมเนียมไม่ถอยไปใช้กฎถัดไป เมื่อแผนที่โหนดใช้อยู่ถูกเลิกใช้ หรือไม่มีเวอร์ชันในสกุลเงินใด คำสั่งในสกุลเงินนั้นจะถูกปฏิเสธ และการแลกรับ GOLD (ทั้งแบบทำเองและ auto-redeem) ก็จะถูกปฏิเสธด้วย รวมถึงสถานะที่ถืออยู่แล้ว",
  "feePlans.newPlan": "แผนค่าธรรมเนียมใหม่",
  "feePlans.list": "แผนค่าธรรมเนียม",
  "feePlans.empty": "ยังไม่มีแผนค่าธรรมเนียม",
  "feePlans.emptyHint": "สร้างแผน เผยแพร่เวอร์ชันสำหรับแต่ละสกุลเงินที่แผนครอบคลุม แล้วจึงกำหนดแผน",
  "feePlans.name": "ชื่อ",
  "feePlans.planId": "รหัสแผน",
  "feePlans.created": "สร้างเมื่อ",
  "feePlans.open": "เปิด",
  "feePlans.detailTitle": "แผนค่าธรรมเนียม: {name}",
  "feePlans.status.active": "ใช้งานอยู่",
  "feePlans.status.retiring": "เลิกใช้ {time}",
  "feePlans.status.retired": "เลิกใช้แล้ว",
  "feePlans.status.protected": "ได้รับการป้องกัน",
  "feePlans.protectedBanner": "แผนนี้ได้รับการป้องกัน เพิ่มเวอร์ชันใหม่หรือเลิกใช้ไม่ได้",
  "feePlans.retiredBanner": "แผนนี้เลิกใช้แล้ว คำสั่งและการแลกรับ GOLD (ทั้งแบบทำเองและ auto-redeem) ที่ใช้แผนนี้จะถูกปฏิเสธจนกว่าขอบเขตนั้นจะได้รับการกำหนดแผนอื่น",
  "feePlans.retiringBanner": "แผนนี้จะเลิกใช้เมื่อ {time} ตั้งแต่เวลานั้น คำสั่งและการแลกรับ GOLD (ทั้งแบบทำเองและ auto-redeem) ที่ใช้แผนนี้จะถูกปฏิเสธจนกว่าขอบเขตนั้นจะได้รับการกำหนดแผนอื่น",
  "feePlans.publishVersion": "เผยแพร่เวอร์ชัน",
  "feePlans.retire": "เลิกใช้แผน",
  "feePlans.versionsIn": "เวอร์ชัน {currency}",
  "feePlans.noVersionsIn": "ยังไม่มีเวอร์ชัน {currency} คำสั่งใน {currency} ที่ใช้แผนนี้จะถูกปฏิเสธ",
  "feePlans.col.version": "เวอร์ชัน",
  "feePlans.col.maker": "เมกเกอร์",
  "feePlans.col.taker": "เทกเกอร์",
  "feePlans.col.redemption": "การแลกรับ",
  "feePlans.col.effective": "มีผลเมื่อ",
  "feePlans.col.published": "เผยแพร่เมื่อ",
  "feePlans.versionStatus.current": "ปัจจุบัน",
  "feePlans.versionStatus.scheduled": "ตั้งเวลาไว้",
  "feePlans.versionStatus.superseded": "ถูกแทนที่แล้ว",
  "feePlans.versionStatus.retired": "ไม่ถูกใช้: แผนเลิกใช้แล้ว",
  "feePlans.versionStatus.notTraded": "ไม่ได้ซื้อขาย",
  "feePlans.create.title": "แผนค่าธรรมเนียมใหม่",
  "feePlans.create.body": "แผนเริ่มต้นแบบว่าง อัตรามาพร้อมกับเวอร์ชันทีละสกุลเงิน และยังไม่มีผลกับใครจนกว่าจะกำหนดแผน",
  "feePlans.create.name": "ชื่อแผน",
  "feePlans.create.nameHint": "ไม่เกิน 200 ตัวอักษร",
  "feePlans.create.confirm": "สร้างแผน",
  "feePlans.publish.title": "เผยแพร่เวอร์ชันของ {name}",
  "feePlans.publish.body": "เวอร์ชันที่เผยแพร่แล้วแก้ไขไม่ได้ ทุกโหนดที่กฎชี้มาที่แผนนี้จะใช้เวอร์ชันนี้ตั้งแต่เวลาเริ่มมีผล",
  "feePlans.publish.currency": "สกุลเงิน",
  "feePlans.publish.current": "เวอร์ชัน {currency} ปัจจุบัน: เมกเกอร์ {maker} เทกเกอร์ {taker} การแลกรับ {redemption}",
  "feePlans.publish.noCurrent": "ขณะนี้ไม่มีเวอร์ชัน {currency} ที่มีผล",
  "feePlans.publish.maker": "อัตราเมกเกอร์ (%)",
  "feePlans.publish.taker": "อัตราเทกเกอร์ (%)",
  "feePlans.publish.redemption": "อัตราการแลกรับ (%)",
  "feePlans.publish.rateHint": "0 ถึง 100 ทศนิยมไม่เกิน 4 ตำแหน่ง",
  "feePlans.publish.redemptionGoldOnly": "ค่าธรรมเนียมการแลกรับใช้กับ GOLD เท่านั้น เวอร์ชัน {currency} จึงเป็น 0",
  "feePlans.publish.rateError.empty": "กรอกอัตรา",
  "feePlans.publish.rateError.invalid": "กรอกตัวเลข และใช้จุดสำหรับทศนิยม",
  "feePlans.publish.rateError.tooPrecise": "ทศนิยมได้ไม่เกิน 4 ตำแหน่ง",
  "feePlans.publish.rateError.tooHigh": "ไม่เกิน 100%",
  "feePlans.publish.ceiling": "อัตราเมกเกอร์รวมและอัตราเทกเกอร์รวม (ของตลาดบวกของโบรกเกอร์) แต่ละอัตราต้องไม่เกิน 100% ระบบตรวจสอบเมื่อรับคำสั่งซื้อขาย ไม่ใช่ตอนนี้ เวอร์ชันที่เกินเพดานจะทำให้คำสั่งที่ได้รับผลกระทบทั้งหมดล้มเหลว",
  "feePlans.publish.redemptionCeiling": "อัตราการแลกรับนี้รวมกับอัตราการแลกรับ GOLD สูงสุดของตลาดต้องไม่เกิน 100% เซิร์ฟเวอร์ตรวจสอบตอนนี้",
  "feePlans.publish.redemptionPricing": "อัตรา maker และ taker จะถูกล็อกเมื่อรับคำสั่ง แต่ค่าธรรมเนียมการแลกรับไม่ถูกล็อก: การแลกรับคิดราคาด้วยเวอร์ชัน GOLD ที่มีผลอยู่ ณ เวลาที่ผู้ใช้แลกรับ (หรือเมื่อ auto-redeem ทำงาน) อัตราการแลกรับใหม่จึงมีผลกับสถานะที่ผู้ใช้ถืออยู่แล้วด้วย",
  "feePlans.publish.redemptionRises": "อัตราการแลกรับนี้สูงกว่าของเวอร์ชัน GOLD ปัจจุบัน และจะมีผลกับการแลกรับทุกรายการตั้งแต่เวลาที่มีผล รวมถึงสถานะที่ผู้ใช้ถืออยู่แล้วและ auto-redeem ไม่ใช่เฉพาะคำสั่งที่ส่งหลังจากนั้น",
  "feePlans.publish.precision": "ระบบส่งอัตราเป็นจำนวนเต็มที่ความละเอียด {precision} ตำแหน่ง: 1% คือ 10000",
  "feePlans.publish.confirm": "เผยแพร่เวอร์ชัน",
  "feePlans.retireDialog.title": "เลิกใช้ {name} หรือไม่",
  "feePlans.retireDialog.body": "การเลิกใช้เป็นการถาวร ตั้งแต่นั้นแผนจะไม่รับเวอร์ชันหรือการกำหนดใหม่",
  "feePlans.retireDialog.warning": "แผนที่เลิกใช้แล้วจะปฏิเสธคำสั่งและการแลกรับ GOLD ทุกรายการ (ทั้งแบบทำเองและ auto-redeem รวมถึงสถานะที่ถืออยู่แล้ว) ภายใต้ขอบเขตที่ยังชี้มายังแผนนี้ และกฎค่าธรรมเนียมไม่ถอยไปใช้กฎถัดไป ระบบจึงปฏิเสธการเลิกใช้ (BROKER_FEE_PLAN_IN_USE) ขณะที่ยังมีกฎชี้มายังแผนนี้ ณ หรือหลังเวลาเลิกใช้ โปรดกำหนดแผนใหม่หรือล้างกฎของขอบเขตเหล่านั้นก่อน คำสั่งที่รับไปแล้วยังคงใช้อัตรา maker และ taker ที่ล็อกไว้ ส่วนการแลกรับจะคิดราคาเมื่อผู้ใช้แลกรับ",
  "feePlans.retireDialog.when": "เลิกใช้เมื่อ",
  "feePlans.retireDialog.confirm": "เลิกใช้แผน",
  "feePlans.tabs": "ส่วนของการจัดการแผน",
  "feePlans.tab.feePlans": "แผนค่าธรรมเนียม",
  "feePlans.tab.feeAssignments": "การกำหนดแผนค่าธรรมเนียม",
  "nodePicker.change": "เปลี่ยน",
  "nodePicker.browse": "โหนดในลำดับชั้น",
  "nodePicker.pick": "เลือก {name}",
  "scopePicker.scope": "ขอบเขต",
  "scopePicker.scope.GROUP": "กลุ่ม",
  "scopePicker.scope.BRANCH": "สาขา",
  "scopePicker.scope.NODE": "โหนด",
  "scopePicker.explain.GROUP": "ทั้งลำดับชั้น: ทุกโหนดที่ไม่มีกฎระดับ BRANCH หรือ NODE ที่ใกล้กว่าครอบคลุมอยู่",
  "scopePicker.explain.BRANCH": "โหนดหนึ่งและทุกโหนดที่อยู่ใต้โหนดนั้น เว้นแต่มีกฎระดับ BRANCH ที่ใกล้กว่าหรือกฎระดับ NODE ครอบคลุมอยู่",
  "scopePicker.explain.NODE": "เฉพาะผู้ใช้ของโหนดนี้เท่านั้น และมีลำดับเหนือกฎระดับ BRANCH ทุกกฎและกฎระดับ GROUP",
  "scopePicker.target": "เป้าหมาย",
  "scopePicker.groupTarget": "กฎระดับ GROUP มีเป้าหมายเป็นโหนดรากเสมอ",
  "feeAssign.title": "การกำหนดแผนค่าธรรมเนียม",
  "feeAssign.new": "กำหนดแผนใหม่",
  "feeAssign.historyNote": "ประวัติของกฎค่าธรรมเนียม เรียงจากเวลาเริ่มมีผลล่าสุด ไม่ใช่สิ่งที่ใช้อยู่ในขณะนี้ หน้าค่าธรรมเนียมของแต่ละโหนดแสดงแผนที่เซิร์ฟเวอร์ระบุให้โหนดนั้น",
  "feeAssign.empty": "ยังไม่มีการกำหนดแผนค่าธรรมเนียม",
  "feeAssign.emptyHint": "หากไม่มีการกำหนด คำสั่งซื้อขายของผู้ใช้ในลำดับชั้นนี้จะถูกปฏิเสธ (NO_ASSIGNMENT)",
  "feeAssign.plan": "แผนค่าธรรมเนียม",
  "feeAssign.cleared": "ยกเลิกกฎแล้ว",
  "feeAssign.clearedHint": "ไม่มีกฎในขอบเขตนี้ตั้งแต่เวลานั้น",
  "feeAssign.dialogTitle": "กำหนดแผนค่าธรรมเนียมหรือยกเลิกกฎ",
  "feeAssign.dialogBody": "การกำหนดที่บันทึกแล้วแก้ไขไม่ได้ และไม่เปลี่ยนราคาของคำสั่งที่รับไปแล้ว",
  "feeAssign.confirm": "กำหนดแผน",
  "feeAssign.confirmClear": "ยกเลิกกฎ",
  "feeAssign.choosePlan": "เลือกแผน…",
  "feeAssign.planRetiring": "{name} (เลิกใช้ {time})",
  "feeAssign.clearOption": "ยกเลิกกฎ: ไม่มีแผนค่าธรรมเนียมในขอบเขตนี้",
  "feeAssign.planHint": "แสดงเฉพาะแผนที่ยังไม่เลิกใช้ ณ เวลาเริ่มมีผล",
  "feeAssign.fromNow": "ตอนนี้",
  "feeAssign.clearWarning": "ตั้งแต่ {at} ขอบเขตนี้จะไม่มีกฎค่าธรรมเนียม โหนดในขอบเขตจะถอยไปใช้กฎถัดไปบนเส้นทาง (BRANCH ที่ใกล้ที่สุด แล้วจึง GROUP) และคำสั่งซื้อขายและการแลกรับ GOLD (ทั้งแบบทำเองและ auto-redeem) จะถูกปฏิเสธ (NO_ASSIGNMENT) ในที่ที่ไม่มีกฎเหลืออยู่",
  "feeAssign.coverageNone": "{currency}: แผนนี้ไม่มีเวอร์ชัน {currency} ที่มีผล ณ เวลานั้น คำสั่งซื้อขายใน {currency} ภายใต้กฎนี้จะถูกปฏิเสธ (NO_VERSION_IN_CURRENCY) และไม่ถอยไปใช้กฎอื่น",
  "feeAssign.coverageLater": "{currency}: เวอร์ชัน {currency} แรกของแผนนี้จะมีผลเมื่อ {time} เท่านั้น ก่อนถึงเวลานั้น คำสั่งซื้อขายใน {currency} ภายใต้กฎนี้จะถูกปฏิเสธ (NO_VERSION_IN_CURRENCY) และไม่ถอยไปใช้กฎอื่น",
  "feeAssign.order": "กฎที่ใช้กับคำสั่งซื้อขาย: กฎระดับ NODE บนโหนดที่ให้บริการ จากนั้นกฎระดับ BRANCH ที่ใกล้ที่สุดบนเส้นทาง (BRANCH บนโหนดรากมีลำดับเหนือ GROUP) แล้วจึงกฎระดับ GROUP",
  "feeAssign.clearFallsBack": "การยกเลิกกฎจะลบกฎของขอบเขตนี้ตั้งแต่เวลาเริ่มมีผล การหาแผนจึงถอยขึ้นไปตามเส้นทาง",
  "feeAssign.noFallback": "กฎที่แผนเลิกใช้แล้ว หรือไม่มีเวอร์ชันในสกุลเงินใด จะปฏิเสธคำสั่งในสกุลเงินนั้น และหากเป็น GOLD จะปฏิเสธการแลกรับด้วย (ทั้งแบบทำเองและ auto-redeem) กฎค่าธรรมเนียมไม่ข้ามไปใช้กฎที่กว้างกว่า",
  "feePlans.tab.sharePlans": "แผนแบ่งรายได้",
  "feePlans.tab.shareAssignments": "การกำหนดแผนแบ่งรายได้",
  "sharePlans.rulesTitle": "หลักการทำงานของแผนแบ่งรายได้",
  "sharePlans.rule.shape": "เวอร์ชันหนึ่งแบ่งค่าคอมมิชชันของโบรกเกอร์: แต่ละส่วนแบ่งอยู่ระหว่าง 1 ถึง 10,000 เบสิสพอยต์ ส่วนแบ่งรวมต้องเท่ากับ 10,000 (100%) พอดี ผู้รับแต่ละรายปรากฏได้ครั้งเดียว และผู้รับเศษที่เหลือต้องมีส่วนแบ่ง",
  "sharePlans.rule.recipients": "ผู้รับคือโหนดในลำดับชั้นนี้ หรือโบรกเกอร์ที่ให้บริการ (@servicing) ซึ่งคือโหนดที่ให้บริการคำสั่งนั้น",
  "sharePlans.rule.path": "ผู้รับที่ระบุชื่อต้องเป็นเป้าหมายของการกำหนดหรือโหนดที่อยู่เหนือเป้าหมาย เพื่อให้อยู่บนเส้นทางของทุกคำสั่งที่ใช้การแบ่งนั้น (OFF_PATH) และเวอร์ชันที่มีส่วนแบ่งของโบรกเกอร์ที่ให้บริการจะระบุเป้าหมายเพิ่มอีกไม่ได้ (SERVICING_NAMED_TWICE)",
  "sharePlans.rule.fallback": "กฎการแบ่งรายได้ถอยไปใช้กฎถัดไปได้ แต่กฎค่าธรรมเนียมไม่ได้ แผนแบ่งรายได้ที่เลิกใช้แล้ว หรือยังไม่มีเวอร์ชันที่มีผล จะถูกข้าม และการหาการแบ่งจะไปยังกฎถัดไปบนเส้นทาง หรือการแบ่งเริ่มต้น คือ 100% ให้โบรกเกอร์ที่ให้บริการ",
  "sharePlans.rule.immutable": "เวอร์ชันและการกำหนดแก้ไขไม่ได้ และคำสั่งที่รับไปแล้วยังคงใช้การแบ่งที่ล็อกไว้",
  "sharePlans.list": "แผนแบ่งรายได้",
  "sharePlans.newPlan": "แผนแบ่งรายได้ใหม่",
  "sharePlans.empty": "ยังไม่มีแผนแบ่งรายได้",
  "sharePlans.emptyHint": "หากไม่มีแผน ทุกคำสั่งจะใช้การแบ่งเริ่มต้น คือ 100% ให้โบรกเกอร์ที่ให้บริการ",
  "sharePlans.currentVersion": "เวอร์ชันปัจจุบัน",
  "sharePlans.noVersionYet": "ยังไม่มี",
  "sharePlans.detailTitle": "แผนแบ่งรายได้: {name}",
  "sharePlans.retiredBanner": "แผนนี้เลิกใช้แล้ว ขอบเขตที่กำหนดแผนนี้จะข้ามแผนนี้ไป และคำสั่งจะถอยไปใช้กฎถัดไปหรือการแบ่งเริ่มต้น",
  "sharePlans.retiringBanner": "แผนนี้จะเลิกใช้เมื่อ {time} ตั้งแต่เวลานั้น ขอบเขตที่กำหนดแผนนี้จะข้ามแผนนี้ไป และคำสั่งจะถอยไปใช้กฎถัดไปหรือการแบ่งเริ่มต้น",
  "sharePlans.noCurrentBanner": "ยังไม่มีเวอร์ชันที่มีผล ก่อนจะมีเวอร์ชัน กฎที่ใช้แผนนี้จะถูกข้าม และคำสั่งจะถอยไปใช้กฎถัดไป",
  "sharePlans.noVersions": "ยังไม่มีเวอร์ชัน เผยแพร่เวอร์ชันเพื่อกำหนดการแบ่งของแผน",
  "sharePlans.versions": "เวอร์ชัน",
  "sharePlans.shares": "ส่วนแบ่ง",
  "sharePlans.create.title": "แผนแบ่งรายได้ใหม่",
  "sharePlans.create.body": "แผนเริ่มต้นแบบว่าง การแบ่งมาพร้อมกับเวอร์ชันแรก และยังไม่มีผลกับใครจนกว่าจะกำหนดแผน",
  "sharePlans.publish.title": "เผยแพร่เวอร์ชันของ {name}",
  "sharePlans.publish.body": "เวอร์ชันที่เผยแพร่แล้วแก้ไขไม่ได้ แบบร่างเริ่มจากเวอร์ชันล่าสุดของแผน ส่วนคำสั่งที่รับไปแล้วยังคงใช้การแบ่งที่ล็อกไว้",
  "sharePlans.retireWarning": "การเลิกใช้เป็นการถาวร ตั้งแต่นั้น ทุกขอบเขตที่กำหนดแผนนี้จะข้ามแผนนี้ไป การหาการแบ่งจะถอยไปยังกฎถัดไปบนเส้นทาง หรือการแบ่งเริ่มต้น คือ 100% ให้โบรกเกอร์ที่ให้บริการ คำสั่งที่รับไปแล้วยังคงใช้การแบ่งที่ล็อกไว้ ส่วนค่าธรรมเนียมการแลกรับจะแบ่งตามเวอร์ชันที่มีผล ณ เวลาที่แลกรับ",
  "shares.editor": "ส่วนแบ่ง",
  "shares.recipient": "ผู้รับ",
  "shares.shareBps": "ส่วนแบ่ง (bps)",
  "shares.percent": "เปอร์เซ็นต์",
  "shares.servicing": "โบรกเกอร์ที่ให้บริการ (@servicing)",
  "shares.bpsFor": "ส่วนแบ่งของ {name} เป็นเบสิสพอยต์",
  "shares.remove": "นำออก",
  "shares.removeFor": "นำ {name} ออก",
  "shares.rowError.empty": "กรอกส่วนแบ่ง",
  "shares.rowError.invalid": "กรอกเป็นจำนวนเต็มเบสิสพอยต์เท่านั้น",
  "shares.rowError.range": "ตั้งแต่ 1 ถึง 10,000 bps",
  "shares.rowError.repeated": "ผู้รับนี้อยู่ในการแบ่งแล้ว",
  "shares.total": "รวม: {total} จาก {max} bps ({percent})",
  "shares.totalMustBe": "ส่วนแบ่งรวมต้องเท่ากับ {max} bps พอดี",
  "shares.addNode": "เพิ่มโหนด",
  "shares.addServicing": "เพิ่มโบรกเกอร์ที่ให้บริการ",
  "shares.pickRecipient": "โหนดผู้รับ",
  "shares.pickHint": "โหนดในลำดับชั้นนี้ โหนดที่ปิดแล้วรับส่วนแบ่งไม่ได้",
  "shares.remainder": "ผู้รับเศษที่เหลือ",
  "shares.chooseRemainder": "เลือกผู้รับ…",
  "shares.remainderMissing": "เลือกผู้รับเศษที่เหลือที่มีส่วนแบ่ง",
  "shares.remainderHint": "รับเศษที่เหลือจากการปัดในการแบ่งแต่ละครั้ง และต้องมีส่วนแบ่ง",
  "shares.belowRoot": "{names}: อยู่ใต้โหนดราก เวอร์ชันที่ระบุโหนดเหล่านี้กำหนดได้เฉพาะในที่ที่แต่ละโหนดอยู่บนเส้นทางของทุกคำสั่ง คือที่โหนดนั้นหรือโหนดที่อยู่ใต้โหนดนั้น ในขอบเขต BRANCH หรือ NODE กฎระดับ GROUP หรือเป้าหมายที่อื่นในลำดับชั้นจะถูกปฏิเสธ (OFF_PATH)",
  "shares.servicingBesideNamed": "เวอร์ชันนี้มีส่วนแบ่งของโบรกเกอร์ที่ให้บริการคู่กับโหนดที่ระบุชื่อ จึงกำหนดให้โหนดที่ระบุชื่อไม่ได้ เพราะในคำสั่งของโหนดนั้นเองทั้งสองคือโบรกเกอร์เดียวกัน (SERVICING_NAMED_TWICE)",
  "shareAssign.title": "การกำหนดแผนแบ่งรายได้",
  "shareAssign.plan": "แผนแบ่งรายได้",
  "shareAssign.historyNote": "ประวัติของกฎการแบ่งรายได้ เรียงจากเวลาเริ่มมีผลล่าสุด ไม่ใช่สิ่งที่ใช้อยู่ในขณะนี้ หน้าค่าธรรมเนียมของแต่ละโหนดแสดงการแบ่งที่เซิร์ฟเวอร์ระบุให้โหนดนั้น",
  "shareAssign.empty": "ยังไม่มีการกำหนดแผนแบ่งรายได้",
  "shareAssign.emptyHint": "ทุกคำสั่งใช้การแบ่งเริ่มต้น คือ 100% ให้โบรกเกอร์ที่ให้บริการ",
  "shareAssign.dialogTitle": "กำหนดแผนแบ่งรายได้หรือยกเลิกกฎ",
  "shareAssign.dialogBody": "การกำหนดที่บันทึกแล้วแก้ไขไม่ได้ และไม่เปลี่ยนการแบ่งของคำสั่งที่รับไปแล้ว",
  "shareAssign.clearOption": "ยกเลิกกฎ: ไม่มีแผนแบ่งรายได้ในขอบเขตนี้",
  "shareAssign.clearWarning": "ตั้งแต่ {at} ขอบเขตนี้จะไม่มีกฎการแบ่งรายได้ คำสั่งจะถอยไปใช้กฎถัดไปบนเส้นทาง หรือการแบ่งเริ่มต้น คือ 100% ให้โบรกเกอร์ที่ให้บริการ",
  "shareAssign.noVersion": "แผนนี้ไม่มีเวอร์ชันที่มีผล ณ เวลานั้น กฎนี้จะถูกข้าม และคำสั่งจะถอยไปใช้กฎถัดไปบนเส้นทาง หรือการแบ่งเริ่มต้น (100% ให้โบรกเกอร์ที่ให้บริการ) จนกว่าจะมีเวอร์ชันที่มีผล",
  "shareAssign.noVersionUntil": "เวอร์ชันแรกของแผนนี้จะมีผลเมื่อ {time} เท่านั้น ก่อนถึงเวลานั้น กฎนี้จะถูกข้าม และคำสั่งจะถอยไปใช้กฎถัดไปบนเส้นทาง หรือการแบ่งเริ่มต้น (100% ให้โบรกเกอร์ที่ให้บริการ)",
  "shareAssign.planRetires": "แผนนี้จะเลิกใช้เมื่อ {time} ตั้งแต่เวลานั้น กฎนี้จะถูกข้าม และคำสั่งจะถอยไปใช้กฎถัดไปบนเส้นทาง หรือการแบ่งเริ่มต้น",
  "shareAssign.order": "กฎการแบ่งรายได้ที่ใช้กับคำสั่ง: กฎระดับ NODE บนโหนดที่ให้บริการ จากนั้นกฎระดับ BRANCH ที่ใกล้ที่สุดบนเส้นทาง (BRANCH บนโหนดรากมีลำดับเหนือ GROUP) แล้วจึงกฎระดับ GROUP",
  "shareAssign.fallback": "กฎการแบ่งรายได้ถอยไปใช้กฎถัดไปได้: ขอบเขตที่ยกเลิกกฎแล้ว แผนที่เลิกใช้ หรือแผนที่ไม่มีเวอร์ชันที่มีผล จะถูกข้ามไปจนถึงการแบ่งเริ่มต้น",
  "shareAssign.path": "ผู้รับที่ระบุชื่อทุกรายในเวอร์ชันปัจจุบันและเวอร์ชันที่ตั้งเวลาไว้ของแผนต้องเป็นเป้าหมายหรือโหนดที่อยู่เหนือเป้าหมาย (OFF_PATH) และเวอร์ชันที่มีส่วนแบ่งของโบรกเกอร์ที่ให้บริการจะระบุเป้าหมายไม่ได้ (SERVICING_NAMED_TWICE) มิฉะนั้นเซิร์ฟเวอร์จะปฏิเสธการกำหนด",

  "funding.title": "เงินทุน",
  "funding.subtitle": "พูล บัญชีชำระ และการโอนของโหนดนี้ ยอดทุกรายการอ่านจากบัญชีแยกประเภทแบบเรียลไทม์",
  "funding.transferNeedsRole": "การโอนเงินในพูลต้องมีสมาชิกภาพเจ้าของหรือการเงินบนโหนดนี้โดยตรง",
  "funding.pool": "พูล",
  "funding.noPool": "โหนดนี้ไม่มีพูลสกุล {currency}",
  "funding.noPoolHint": "โหมดการซื้อขายของโหนดเป็นตัวกำหนดสกุลเงินที่โหนดถือ",
  "funding.available": "ใช้ได้",
  "funding.reserved": "กันไว้",
  "funding.pendingWithdrawal": "รอถอน",
  "funding.canSpendReceive": "ใช้จ่ายได้ / รับได้",
  "funding.canSpendReceiveValue": "{spend} / {receive}",
  "funding.clearing": "ยอดบัญชีชำระ",
  "funding.transfers": "การโอน",
  "funding.noTransfers": "ไม่มีการโอนในสกุลเงินนี้",
  "funding.kind": "ประเภท",
  "funding.fromTo": "จาก → ถึง",
  "funding.amount": "จำนวนเงิน",
  "funding.actor": "ผู้เริ่มรายการ",
  "funding.operation": "รายการปฏิบัติการ",
  "funding.poolAvailable": "พูลที่ใช้ได้",
  "funding.poolReserved": "พูลที่กันไว้",
  "funding.allocatedToUsers": "จัดสรรให้ผู้ใช้ (สุทธิ)",
  "funding.returnable": "คืนให้โหนดแม่ได้",
  "transfer.open": "โอนเงินในพูล",
  "transfer.title": "โอนเงินในพูล",
  "transfer.body": "โอนเงินในพูลของโหนดนี้ผ่านเส้นเชื่อมโดยตรงหนึ่งเส้น: ไปยังโหนดลูกโดยตรง หรือคืนให้โหนดแม่",
  "transfer.available": "ยอดที่ใช้ได้ในพูลนี้:",
  "transfer.direction": "ทิศทาง",
  "transfer.allocate": "จัดสรรให้โหนดลูกโดยตรง",
  "transfer.return": "คืนให้โหนดแม่",
  "transfer.destination": "ปลายทาง",
  "transfer.parent": "โหนดแม่ {id}",
  "transfer.noParent": "โหนดนี้ไม่มีโหนดแม่ โหนดรากจ่ายเงินออกผ่านบัญชีหลักแทน",
  "transfer.noChildren": "โหนดนี้ไม่มีโหนดลูกโดยตรงที่ใช้งานอยู่",
  "transfer.amount": "จำนวนเงิน ({currency})",
  "transfer.amountHint": "ทศนิยมได้ไม่เกิน 4 ตำแหน่ง",
  "transfer.amountError.empty": "กรอกจำนวนเงิน",
  "transfer.amountError.invalid": "กรอกตัวเลข",
  "transfer.amountError.tooPrecise": "ทศนิยมได้ไม่เกิน 4 ตำแหน่ง",
  "transfer.amountError.notPositive": "ต้องมากกว่าศูนย์",
  "transfer.reference": "เลขอ้างอิงภายนอก (ไม่บังคับ)",
  "transfer.submit": "โอน",
  "transfer.retrySame": "ตรวจสอบอีกครั้งด้วยคำขอเดิม",
  "transfer.closeLocked": "ปิด แล้วตรวจสอบรายการโอน",
  "transfer.lockedBody": "ยังไม่ทราบผลของการโอนนี้ ส่งได้เฉพาะคำขอเดิมซ้ำเท่านั้น เซิร์ฟเวอร์จะตอบด้วยรายการโอนเดิมแทนการโอนเงินซ้ำ",
  "transfer.requestKey": "รหัสคำขอ {key}",
  "transfer.replayed": "ตอบซ้ำ เป็นรายการโอนเดิม",
  "transfer.transferId": "รายการโอน",
  "transfer.operationId": "รายการปฏิบัติการ",
  "transfer.outcome.committed": "สำเร็จ: โอนเงินแล้ว",
  "transfer.outcome.refused": "ไม่มีการโอนเงิน บันทึกของรายการโอนระบุเหตุผลไว้",
  "transfer.outcome.unknown": "รอดำเนินการ: บัญชีแยกประเภทยังไม่ยืนยัน อย่าเริ่มการโอนใหม่ ให้ตรวจสอบอีกครั้งด้วยคำขอเดิม",

  "revenue.title": "รายได้",
  "revenue.subtitle": "รายได้ของโหนดนี้ตามสถานะ ตามรอบ และตามรายการ",
  "revenue.balances": "รายได้ตามสถานะ",
  "revenue.noBalance": "ไม่มีรายได้ในสกุล {currency}",
  "revenue.state.pending": "รอดำเนินการ",
  "revenue.state.held": "ถูกระงับไว้",
  "revenue.state.available": "พร้อมใช้",
  "revenue.state.payoutReserved": "กันไว้สำหรับจ่าย",
  "revenue.state.paid": "จ่ายแล้ว",
  "revenue.state.unpaid": "ยังไม่จ่ายทั้งหมด",
  "revenue.pendingSub": "ยังไม่สามารถรับได้",
  "revenue.availableSub": "จ่ายได้ในชุดการจ่ายเงินที่ตลาดจัดเตรียม",
  "revenue.heldSub": "ถูกระงับไม่ให้รวมในการจ่ายเงิน",
  "revenue.reservedSub": "อยู่ในชุดการจ่ายเงิน",
  "revenue.unpaidSub": "รอดำเนินการ ถูกระงับไว้ พร้อมใช้ และกันไว้",
  "revenue.pendingExplained": "รายได้ที่รอดำเนินการยังใช้ไม่ได้ จะพร้อมใช้เมื่อการกระทบยอดรายได้ตรงกับบัญชีแยกประเภทแล้ว",
  "revenue.latestRecon": "การกระทบยอดรายได้ล่าสุด: {state},",
  "revenue.noRecon": "ยังไม่มีการกระทบยอดรายได้",
  "revenue.periods": "รายได้ตามรอบ",
  "revenue.window": "ช่วงเวลา",
  "revenue.kind": "ประเภท",
  "revenue.total": "รวม",
  "revenue.today": "วันนี้",
  "revenue.current": "รอบปัจจุบัน",
  "revenue.previous": "รอบก่อน",
  "revenue.earned": "รายได้จากโหนดเอง",
  "revenue.sharesReceived": "ส่วนแบ่งที่ได้รับ",
  "revenue.periodsNote": "รายได้จากโหนดเอง: รายการที่โหนดนี้ให้บริการเอง ส่วนแบ่งที่ได้รับ: รายการที่โหนดลูกหลานให้บริการ วันนี้คือวันตามเวลาเอเชีย/กรุงเทพฯ รอบเป็นเดือนปฏิทิน (UTC)",
  "revenue.earnings": "รายการรายได้",
  "revenue.noEarnings": "ไม่พบรายการที่ตรงกัน",
  "revenue.origin": "ที่มา",
  "revenue.role": "บทบาท",
  "revenue.source": "แหล่งที่มา",
  "revenue.share": "ส่วนแบ่ง",
  "revenue.amount": "จำนวนเงิน",
  "revenue.held": "ถูกระงับไว้",

  "payouts.title": "การจ่ายเงิน",
  "payouts.subtitle": "ชุดการจ่ายเงินของโหนดนี้ ตลาดเป็นผู้ตรวจสอบ อนุมัติ และจ่ายเงินทุกชุด",
  "payouts.manualNote": "ตลาดจัดเตรียมการจ่ายเงินแต่ละครั้งด้วยตนเองเมื่อชำระยอดกับคุณ",
  "payouts.settlementLink": "ดูสถานะสุทธิและคำขอชำระเงินของคุณได้ที่หน้าการชำระยอด",
  "payouts.cutoff": "วันตัดยอด",
  "payouts.heldNote": "รายได้ที่ถูกระงับไว้จะไม่ถูกรวมในชุดใดจนกว่าจะปลดการระงับ ถูกระงับไว้ขณะนี้:",
  "payouts.batches": "ชุดการจ่ายเงิน",
  "payouts.none": "ไม่มีชุดการจ่ายเงินในสกุลเงินนี้",
  "payouts.nextAction": "ขั้นตอนถัดไป",
  "payouts.total": "ยอดรวม",
  "payouts.items": "รายการรายได้",
  "payouts.batch": "ชุด",
  "payouts.failureReason": "เหตุผล: {reason}",
  "payouts.state.DRAFT": "ฉบับร่าง",
  "payouts.state.PENDING_REVIEW": "รอตรวจสอบ",
  "payouts.state.APPROVED": "อนุมัติแล้ว",
  "payouts.state.PROCESSING": "กำลังดำเนินการ",
  "payouts.state.PAID": "จ่ายแล้ว",
  "payouts.state.FAILED": "ล้มเหลว",
  "payouts.state.REJECTED": "ถูกปฏิเสธ",
  "payouts.state.CANCELLED": "ยกเลิกแล้ว",
  "payouts.next.DRAFT": "กำลังจัดเตรียม ตลาดจะส่งเข้าตรวจสอบ รายได้ของชุดนี้ถูกกันไว้แล้ว",
  "payouts.next.PENDING_REVIEW": "รอฝ่ายการเงินของตลาดตรวจสอบ คุณไม่ต้องดำเนินการใด",
  "payouts.next.APPROVED": "อนุมัติแล้ว ตลาดจะจ่ายเงินนอกระบบ Smart Market",
  "payouts.next.PROCESSING": "ส่งเงินแล้ว รอช่องทางการชำระยืนยัน",
  "payouts.next.PAID": "จ่ายแล้ว ไม่มีสิ่งใดต้องทำ",
  "payouts.next.FAILED": "การจ่ายเงินล้มเหลว รายได้ของชุดนี้กลับเป็นรายได้ที่พร้อมใช้และจะรวมในชุดถัดไป โปรดตรวจสอบรายละเอียดการชำระเงินกับตลาด",
  "payouts.next.REJECTED": "ถูกปฏิเสธจากการตรวจสอบของตลาด รายได้ของชุดนี้กลับเป็นรายได้ที่พร้อมใช้",
  "payouts.next.CANCELLED": "ยกเลิกแล้ว รายได้ของชุดนี้กลับเป็นรายได้ที่พร้อมใช้",
  "payouts.next.unknown": "สถานะที่พอร์ทัลนี้ยังไม่รู้จัก",

  "statements.title": "รายงานสรุป",
  "statements.subtitle": "รายงานสรุปรายได้ของช่วงเวลา พร้อมรายการเคลื่อนไหวที่เกี่ยวข้องทั้งหมด",
  "statements.exportCsv": "ส่งออก CSV",
  "statements.period": "ช่วงเวลา",
  "statements.thisMonth": "เดือนนี้",
  "statements.lastMonth": "เดือนที่แล้ว",
  "statements.fromDay": "ตั้งแต่",
  "statements.toDay": "ถึง (รวมวันนี้)",
  "statements.apply": "ใช้",
  "statements.badRange": "เลือกวันสิ้นสุดที่ตรงหรือหลังวันเริ่มต้น",
  "statements.scope": "รายได้ของ",
  "statements.scopeNode": "โหนดนี้",
  "statements.scopeSubtree": "โหนดนี้และโหนดลูกหลาน",
  "statements.windowDays": "ช่วงเวลา: {from} ถึง {to} รวมทั้งสองวัน เป็นวันเต็มตามเวลา UTC",
  "statements.recon": "การกระทบยอดรายได้ล่าสุด: {state}",
  "statements.generated": "สร้างเมื่อ",
  "statements.noActivity": "ไม่มีรายได้ในสกุลเงินนี้ในช่วงเวลานี้",
  "statements.arithmetic": "รายงานสรุป",
  "statements.arithmeticNote": "ยอดยกมา + รายได้ + ส่วนแบ่งที่ได้รับ + การปรับปรุง + โอนย้ายเข้า − โอนย้ายออก − การจ่ายเงิน = ยอดยกไป ทุกบรรทัดมาจากเซิร์ฟเวอร์",
  "statements.opening": "ยอดยกมา",
  "statements.earnedMaker": "รายได้ · เมกเกอร์",
  "statements.earnedTaker": "รายได้ · เทกเกอร์",
  "statements.earnedRedemption": "รายได้ · การแลกรับ",
  "statements.sharesMaker": "ส่วนแบ่งที่ได้รับ · เมกเกอร์",
  "statements.sharesTaker": "ส่วนแบ่งที่ได้รับ · เทกเกอร์",
  "statements.sharesRedemption": "ส่วนแบ่งที่ได้รับ · การแลกรับ",
  "statements.adjustments": "การปรับปรุง",
  "statements.reassignedIn": "โอนย้ายเข้า",
  "statements.reassignedOut": "โอนย้ายออก",
  "statements.payouts": "การจ่ายเงิน",
  "statements.closing": "ยอดยกไป",
  "statements.closingBreakdown": "ยอดยกไปตามสถานะ",
  "statements.info": "ข้อมูลประกอบ",
  "statements.infoNote": "ยอดรวมจากรายการต้นทาง ค่าคอมมิชชันที่เป็นโมฆะไม่เคยถูกเรียกเก็บและไม่ใช่เงิน",
  "statements.tradedValue": "มูลค่าการซื้อขาย",
  "statements.exchangeFee": "ค่าธรรมเนียมตลาด",
  "statements.brokerCommission": "ค่าคอมมิชชันโบรกเกอร์",
  "statements.voidCommission": "ค่าคอมมิชชันที่เป็นโมฆะ",
  "statements.rows": "รายการเคลื่อนไหวที่เกี่ยวข้อง",
  "statements.noRows": "ไม่มีรายการเคลื่อนไหวในช่วงเวลานี้",
  "statements.rowKind": "ประเภท",
  "statements.recipient": "ผู้รับ",
  "statements.sourceOrRef": "แหล่งที่มาหรือเลขอ้างอิง",
  "statements.effect": "ผลต่อยอดคงเหลือ",

  "recon.title": "การกระทบยอด",
  "recon.subtitle": "การกระทบยอดเงินทุนและรายได้ล่าสุด ตัดเฉพาะส่วนที่อยู่ในขอบเขตของคุณ",
  "recon.funding": "การกระทบยอดเงินทุน",
  "recon.revenue": "การกระทบยอดรายได้",
  "recon.noFundingRun": "ยังไม่มีการกระทบยอดเงินทุน",
  "recon.noRevenueRun": "ยังไม่มีการกระทบยอดรายได้",
  "recon.started": "เริ่มเมื่อ",
  "recon.finished": "เสร็จเมื่อ",
  "recon.runError": "การกระทบยอดอ่านแหล่งข้อมูลไม่ได้: {error}",
  "recon.noRootsInCurrency": "ไม่มีตัวเลขสกุล {currency} ในการกระทบยอดนี้",
  "recon.noItemsInCurrency": "ไม่มีโหนดสกุล {currency} ในการกระทบยอดนี้",
  "recon.root": "ราก",
  "recon.topUps": "การเติมเงิน",
  "recon.payoutsCompleted": "การจ่ายเงินที่เสร็จสิ้น",
  "recon.nodeTotal": "ยอดรวมของโหนด",
  "recon.userAllocations": "การจัดสรรให้ผู้ใช้",
  "recon.userReturns": "การรับคืนจากผู้ใช้",
  "recon.balanced": "สมดุล",
  "recon.findings": "ข้อสังเกต",
  "recon.noFindings": "ไม่มีข้อสังเกตในขอบเขตของคุณ",
  "recon.rule": "กฎ",
  "recon.severity": "ความรุนแรง",
  "recon.node": "โหนด",
  "recon.detail": "รายละเอียด",
  "recon.expected": "ที่คาดไว้",
  "recon.actual": "ที่เกิดจริง",
  "recon.ledgerPending": "บัญชีแยกประเภท รอดำเนินการ",
  "recon.earningsPending": "รายได้ รอดำเนินการ",
  "recon.ledgerAvailable": "บัญชีแยกประเภท พร้อมใช้",
  "recon.earningsAvailable": "รายได้ พร้อมใช้",
  "recon.matched": "ตรงกัน",
  "recon.inFlight": "กำลังดำเนินการ",
  "recon.yes": "ใช่",
  "recon.no": "ไม่",
  "recon.cases": "กรณีความคลาดเคลื่อน",
  "recon.casesAvailable": "มีกรณีความคลาดเคลื่อนให้ดูแล้ว",
  "recon.casesLater": "กรณีความคลาดเคลื่อนจะมาพร้อมระยะ 08d",
  "recon.casesLaterHint": "ระหว่างนี้ ข้อสังเกตด้านบนคือภาพทั้งหมด ระบบไม่แสดงกรณีที่ไม่มีอยู่จริง",
  "recon.caption.fundingSource": "บัญชีแยกประเภทหรือระบบรับฝากสินทรัพย์คริปโตของลำดับชั้นโบรกเกอร์นี้",
  "recon.caption.revenueSource": "ยอดคงเหลือรายได้ในบัญชีแยกประเภท",
  "recon.caption.ledgerFinding": "อ่านสรุปเงินทุนจากบัญชีแยกประเภทไม่ได้",
  "recon.caption.railFinding": "อ่านยอดรวมจากระบบรับฝากสินทรัพย์คริปโตไม่ได้",
  "settlement.title": "การชำระยอด",
  "settlement.subtitle": "ใครค้างจ่ายใคร และเท่าไร ในช่วงเวลาล่าสุด อ่านได้อย่างเดียว: การชำระบันทึกโดยกระดานซื้อขาย",
  "settlement.period": "ช่วงเวลา",
  "settlement.window.1": "24 ชั่วโมงที่ผ่านมา",
  "settlement.window.3": "3 วันที่ผ่านมา",
  "settlement.window.7": "7 วันที่ผ่านมา",
  "settlement.window.14": "14 วันที่ผ่านมา",
  "settlement.window.30": "30 วันที่ผ่านมา",
  "settlement.scope": "ตัวเลข",
  "settlement.scope.subtree": "โหนดนี้และสาขาย่อย",
  "settlement.scope.node": "เฉพาะโหนดนี้",
  "settlement.outstanding": "สถานะสุทธิ (เพื่อทราบเท่านั้น)",
  "settlement.dir.WE_OWE_BROKER": "เราค้างจ่ายคุณ",
  "settlement.dir.BROKER_OWES_US": "คุณค้างจ่ายเรา",
  "settlement.dir.SETTLED": "ชำระครบแล้ว — ไม่มีฝ่ายใดค้างจ่าย",
  "settlement.ifPendingClear": "หากรายการชำระที่รอยืนยันผ่าน",
  "settlement.empty": "ยังไม่มีความเคลื่อนไหวการชำระ",
  "settlement.emptyHint": "ยังไม่มีรายได้ การซื้อขายผ่านบัญชีเคลียริง หรือบันทึกใด ๆ ในสกุลเงินนี้",
  "settlement.transferIn": "ยอดที่หลักประกันไม่ครอบคลุม (เพื่อทราบเท่านั้น)",
  "settlement.covered": "หลักประกันของคุณครอบคลุมยอดแล้ว",
  "settlement.periodTitle": "ช่วงเวลานี้",
  "settlement.sinceLaunch": "ตั้งแต่เริ่มระบบ ถึงสิ้นช่วงเวลา",
  "settlement.revenueReleased": "รายได้ที่พร้อมจ่ายแล้ว",
  "settlement.revenuePaid": "รายได้ที่จ่ายให้คุณแล้ว",
  "settlement.clearingMovement": "ความเคลื่อนไหวบัญชีเคลียริง",
  "settlement.periodNet": "ยอดสุทธิของช่วงเวลา",
  "settlement.revenueAvailable": "รายได้ที่พร้อมจ่าย ยังไม่ได้จ่าย",
  "settlement.clearingBalance": "ยอดบัญชีเคลียริง",
  "settlement.noClearing": "ไม่มีบัญชีเคลียริง — ยอดของคุณมีเฉพาะรายได้",
  "settlement.gross": "ยอดรวมก่อนหักการชำระ",
  "settlement.confirmedIn": "การชำระที่คุณจ่ายเรา (ยืนยันแล้ว)",
  "settlement.confirmedOut": "การชำระที่เราจ่ายคุณ (ยืนยันแล้ว)",
  "settlement.collateral": "หลักประกันที่ถืออยู่",
  "settlement.collateralNote": "พูลเงินทุนล่วงหน้าของคุณ — แสดงข้างยอด ไม่รวมอยู่ในยอด",
  "settlement.uncovered": "ยอดหลังรวมหลักประกัน",
  "settlement.fees": "ค่าธรรมเนียมในช่วงเวลานี้",
  "settlement.tradedValue": "มูลค่าการซื้อขาย",
  "settlement.exchangeFee": "ค่าธรรมเนียมกระดานซื้อขาย",
  "settlement.brokerCommission": "ค่าคอมมิชชันโบรกเกอร์",
  "settlement.branches": "สาขาย่อย",
  "settlement.branchesHint": "แต่ละโหนดลูกพร้อมสาขาย่อยของตน เลือกเพื่อดูรายละเอียด",
  "settlement.thisNode": "เฉพาะโหนดนี้",
  "settlement.open": "เปิด",
  "settlement.noActivity": "ยังไม่มีความเคลื่อนไหว",
  "settlement.notes": "บันทึกการชำระ (บันทึกช่วยจำ)",
  "settlement.notesEmpty": "ยังไม่มีการบันทึกการชำระในสกุลเงินนี้",
  "settlement.noteDir.INBOUND": "คุณจ่ายให้เรา",
  "settlement.noteDir.OUTBOUND": "เราจ่ายให้คุณ",
  "settlement.noteStatus.PENDING": "รอยืนยัน — ยังไม่ยืนยันการได้รับเงิน",
  "settlement.noteStatus.CONFIRMED": "ยืนยันแล้ว",
  "settlement.noteStatus.SUPERSEDED": "ถูกแทนที่แล้ว",
  "settlement.valueDate": "วันที่โอน",
  "settlement.reference": "เลขอ้างอิง",
  "settlement.recordedAt": "บันทึกเมื่อ",
  "settlement.direction": "ใครค้างจ่ายใคร",
  "settlement.externalCredit": "ยอดเครดิตภายนอกที่ค้างชำระ",
  "settlement.externalCreditHint": "ยอดที่คำขอชำระเงินเรียกเก็บ: ยอดเครดิตภายนอกของผู้ใช้ของคุณหลังหักการชำระที่ยืนยันแล้ว แสดงแยกจากสถานะสุทธิ ไม่นำไปรวมกัน",
  "settlement.revenueInPayout": "ค่าคอมมิชชันในชุดการจ่ายเงินที่ยังเปิดอยู่",
  "settlement.usersOpenCost": "สถานะที่ยังเปิดอยู่ของผู้ใช้",
  "settlement.usersSettled": "ผลที่ปิดแล้วและค่าธรรมเนียมของผู้ใช้",
  "settlement.clearingPart": "เป็นส่วนหนึ่งของยอดบัญชีเคลียริง ไม่ได้บวกเพิ่ม",
  "settlement.requestsOpen": "คำขอชำระเงินที่ยังเปิดอยู่",
  "settlement.requestsOpenValue": "{count} รายการ · ยอดคงค้าง",
  "settlement.openReceivable": "ลูกหนี้ที่ค้างอยู่",
  "settlement.receivableState.OPEN": "เปิดอยู่",
  "settlement.receivableState.ACKNOWLEDGED": "รับทราบแล้ว",
  "settlement.requests": "คำขอชำระเงิน",
  "settlement.requestsHint": "ยอดที่กระดานซื้อขายขอให้คุณชำระ คือยอดเครดิตภายนอกที่ค้างชำระ ไม่ใช่สถานะสุทธิ อ่านได้อย่างเดียว: กระดานซื้อขายเป็นผู้บันทึกและยกเลิกคำขอ และคำขอจะชำระแล้วเมื่อการชำระที่ยืนยันแล้วของคุณครอบคลุมยอด",
  "settlement.requestsFilter": "แสดง",
  "settlement.requestsFilter.open": "ที่ยังเปิดอยู่",
  "settlement.requestsFilter.all": "ทั้งหมด",
  "settlement.requestsEmptyOpen": "ไม่มีคำขอชำระเงินที่ยังเปิดอยู่",
  "settlement.requestsEmpty": "ไม่มีคำขอชำระเงิน",
  "settlement.requestNode": "โหนด",
  "settlement.requestThisNode": "โหนดนี้",
  "settlement.requested": "ยอดที่ขอ",
  "settlement.received": "ได้รับแล้ว",
  "settlement.requestOutstanding": "คงค้าง",
  "settlement.dueDate": "วันครบกำหนด",
  "settlement.requestNote": "หมายเหตุ",
  "settlement.requestedAt": "ขอเมื่อ",
  "settlement.overdue": "เกินกำหนด",
  "settlement.requestStatus.REQUESTED": "รอชำระ",
  "settlement.requestStatus.PAID": "ชำระแล้ว",
  "settlement.requestStatus.CANCELLED": "ยกเลิกแล้ว",
  "settlement.paidOn": "ชำระเมื่อ",
  "settlement.cancelReason": "เหตุผล: {reason}",
  "settlement.openRequestsColumn": "คำขอที่เปิดอยู่",
  "settlement.noteForRequest": "สำหรับคำขอชำระเงิน {id}",

  // --- SM-941: server captions, finding details, enums ---
  "settlement.caption.outstanding": "สถานะสุทธิ ใช้เพื่อดูข้อมูลเท่านั้น ไม่มีการส่งหรือเรียกเก็บเป็นยอดเดียว",
  "settlement.caption.noteMemo": "บันทึกช่วยจำ: บันทึกการโอนผ่านธนาคารภายนอก ไม่ใช่เงินที่ได้รับ และไม่เปลี่ยนยอดคงเหลือ หลักประกัน หรือวงเงินคงเหลือ",
  "settlement.caption.noteInbound": "เป็นบันทึกเท่านั้น ไม่ได้เติมเงินเข้าพูลของโบรกเกอร์ วงเงินคงเหลือเปลี่ยนเมื่อมีการเติมเงินเข้ากระเป๋าหลักจริงเท่านั้น",
  "settlement.caption.noteOutbound": "บันทึกการดำเนินการทางการเงินด้วยตนเอง ไม่มีการสร้างชุดการจ่ายเงิน และไม่มีรายได้ใดถูกระบุว่าจ่ายแล้ว",
  "settlement.caption.paymentRequest": "คำขอชำระยอดเครดิตภายนอกที่โบรกเกอร์ค้างชำระ ไม่ใช่สถานะสุทธิ คำขอนี้ไม่ได้ย้ายเงิน และจะถือว่าชำระแล้วเมื่อการชำระขาเข้าได้รับการยืนยัน",
  "settlement.externalCreditSubtree": "ยอดรวมของโหนดนี้และสาขาย่อย คำขอชำระเงินแต่ละรายการเรียกเก็บจากโหนดเดียวตามยอดของโหนดนั้น ไม่ใช่ยอดรวมนี้",
  "clearing.beforeSettlements": "สถานะบัญชีชำระตามบัญชีแยกประเภท บันทึกการชำระและการชำระนอกแพลตฟอร์มไม่ได้บันทึกลงบัญชีแยกประเภท จึงไม่ลดยอดนี้",
  "clearing.seeSettlement": "ดูยอดที่ยังค้างชำระในหน้าการชำระยอด",
  "reconDetail.LEDGER_OTHER_CURRENCY": "บัญชีแยกประเภทตอบกลับบัญชีในสกุลเงินอื่น",
  "reconDetail.LEDGER_UNREADABLE": "อ่านสรุปเงินทุนจากบัญชีแยกประเภทไม่ได้",
  "reconDetail.LEDGER_UNAVAILABLE": "ไม่สามารถอ่านสรุปเงินทุนจากบัญชีแยกประเภทได้ จึงไม่ได้ตรวจสอบลำดับชั้นนี้",
  "reconDetail.ROOT_UNBALANCED": "ยอดเติมเงินหักการจ่ายเงินที่เสร็จสิ้น ไม่เท่ากับยอดรวมของโหนดบวกเงินที่จัดสรรให้ผู้ใช้หักเงินที่ผู้ใช้คืน",
  "reconDetail.NODE_TOTAL_UNEXPLAINED": "ยอดรวมของโหนด (ใช้ได้ กันไว้ และรอถอน) ไม่ตรงกับรายการเคลื่อนไหวของเงินทุนของโหนด",
  "reconDetail.OPERATION_LEG_COUNT": "รายการโอนเงินทุนหนึ่งรายการต้องมีสองขาพอดี",
  "reconDetail.OPERATION_LEGS_DIFFER": "ขาออกและขาเข้าของรายการโอนไม่เท่ากัน",
  "reconDetail.OPERATION_OTHER_CURRENCY": "ขาของรายการโอนอยู่ในสกุลเงินอื่น",
  "reconDetail.POOL_NO_LEDGER_ACCOUNT": "พูลในทะเบียนไม่มีบัญชีในบัญชีแยกประเภท",
  "reconDetail.POOL_WALLET_MISMATCH": "ทะเบียนบันทึกกระเป๋าเงินคนละใบกับที่บัญชีแยกประเภทถืออยู่",
  "reconDetail.COMMITTED_NO_OPERATION": "การโอนที่บันทึกสำเร็จแล้วไม่มีรายการในบัญชีแยกประเภท",
  "reconDetail.PAIR_AMOUNT_DIFFERS": "ยอดในบัญชีแยกประเภทไม่ตรงกับยอดในทะเบียน",
  "reconDetail.PAIR_SOURCE_KIND_DIFFERS": "บัญชีแยกประเภทบันทึกการเคลื่อนไหวคนละประเภทกับทะเบียน",
  "reconDetail.PAIR_ACCOUNTS_DIFFER": "บัญชีแยกประเภทย้ายเงินระหว่างบัญชีที่ไม่ตรงกับที่ทะเบียนระบุ",
  "reconDetail.FAILED_HAS_LEGS": "การโอนที่ล้มเหลวมีรายการในบัญชีแยกประเภท",
  "reconDetail.PENDING_TOO_OLD": "การโอนที่รอดำเนินการค้างนานเกิน {minutes} นาที",
  "reconDetail.TRANSFER_MANUAL_REVIEW": "การโอนรอเจ้าหน้าที่ตรวจสอบ หลังจากผลจากบัญชีแยกประเภทไม่ชัดเจนหลายครั้ง",
  "reconDetail.OPERATION_NO_REGISTRY_ROW": "รายการโอนเงินทุนในบัญชีแยกประเภทไม่มีบันทึกในทะเบียน",
  "reconDetail.RAIL_UNAVAILABLE": "อ่านยอดรวมจากระบบรับฝากสินทรัพย์คริปโตไม่ได้",
  "reconDetail.RAIL_UNREADABLE": "ยอดรวมจากระบบรับฝากสินทรัพย์คริปโตอ่านไม่ออก",
  "reconDetail.RAIL_DEPOSITS_DIFFER": "ยอดฝากที่เข้าบัญชีแล้วไม่ตรงกับยอดเติมเงินคริปโตของบัญชีหลัก",
  "reconDetail.RAIL_WITHDRAWALS_DIFFER": "ยอดถอนที่เสร็จสิ้นไม่ตรงกับยอดจ่ายเงินคริปโตที่เสร็จสิ้นของบัญชีหลัก",
  "reconDetail.RAIL_OPEN_WITHDRAWALS_DIFFER": "ยอดถอนที่ยังเปิดอยู่ไม่ตรงกับยอดรอถอนของบัญชีหลัก",
  "reconDetail.PAYOUT_HOLD_TOO_OLD": "การกันเงินเพื่อจ่ายของบัญชีหลักเปิดค้างนานเกิน {hours} ชั่วโมง",
  "reconDetail.OTHER_LEG_KIND": "บัญชีแยกประเภทมีรายการเคลื่อนไหวประเภทอื่นในบัญชีโบรกเกอร์",
  "reconDetail.MANUAL_RAIL_NON_ROOT": "มีการสร้างหรือทำลายเงินด้วยตนเองในพูลที่ไม่ใช่ของโหนดราก",
  "reconDetail.CRYPTO_RAIL_NON_ROOT": "มีรายการเติมเงินหรือจ่ายเงินคริปโตในพูลที่ไม่ใช่ของโหนดราก",
  "reconSeverity.ERROR": "ข้อผิดพลาด",
  "reconSeverity.MANUAL_REVIEW": "รอเจ้าหน้าที่ตรวจสอบ",
  "accountEvent.CREATE": "สร้างบัญชี",
  "accountEvent.SUSPEND": "ระงับ",
  "accountEvent.RESUME": "กลับมาใช้งาน",
  "accountEvent.CLOSE": "ปิดบัญชี",
  "auditEntity.BROKER": "โบรกเกอร์",
  "auditEntity.SETTINGS": "การตั้งค่า",
  "auditEntity.MEMBERSHIP": "สมาชิกภาพพนักงาน",
  "auditEntity.HIERARCHY": "ลำดับชั้น",
  "auditEntity.PAYOUT_SETTING": "การตั้งค่าการจ่ายเงิน",
  "auditEntity.PAYOUT_DESTINATION": "ปลายทางการจ่ายเงิน",
  "auditEntity.CLEARING_ACCOUNT": "บัญชีชำระ",
  "auditEntity.FEE_PLAN": "แผนค่าธรรมเนียม",
  "auditEntity.FEE_PLAN_VERSION": "ฉบับของแผนค่าธรรมเนียม",
  "auditEntity.FEE_ASSIGNMENT": "การกำหนดแผนค่าธรรมเนียม",
  "auditEntity.EXPOSURE_LIMIT": "วงเงินความเสี่ยง",
  "auditEntity.EXPOSURE_LIMIT_REQUEST": "คำขอเปลี่ยนวงเงินความเสี่ยง",
  "auditEntity.RECEIVABLE": "ลูกหนี้",
  "auditEntity.RECEIVABLE_ACTION": "การดำเนินการกับลูกหนี้",
  "auditEntity.POOL": "พูล",
  "auditEntity.FUNDING_TRANSFER": "การโอนเงินทุน",
  "auditEntity.CREDENTIAL": "ข้อมูลรับรองเซิร์ฟเวอร์",
  "auditEntity.PAYOUT_BATCH": "ชุดการจ่ายเงิน",
  "auditEntity.PROVIDER_CONFIG": "การตั้งค่าผู้ให้บริการ",
  "auditEntity.PAYMENT_REQUEST": "คำขอชำระเงิน",
  "auditEntity.REVENUE_SHARE_PLAN": "แผนแบ่งรายได้",
  "auditEntity.REVENUE_SHARE_VERSION": "ฉบับของแผนแบ่งรายได้",
  "auditEntity.REVENUE_SHARE_ASSIGNMENT": "การกำหนดแผนแบ่งรายได้",
  "auditEntity.SETTLEMENT_NOTE": "บันทึกการชำระ",
  "auditEntity.CURRENCY_IMAGE": "รูปสกุลเงิน",
  "auditEntity.REVENUE_ADJUSTMENT": "การปรับรายได้",
  "auditEntity.REVENUE_REASSIGNMENT": "การโอนรายได้ให้ผู้รับรายอื่น",
  "auditEntity.REVENUE_HOLD": "การระงับรายได้",
  "cancelReason.USER_REQUESTED": "ผู้ใช้ยกเลิก",
  "cancelReason.SELF_MATCH_PREVENTED": "ป้องกันการจับคู่กับคำสั่งของผู้ใช้เอง",
  "cancelReason.NO_LIQUIDITY": "ไม่มีสภาพคล่อง",
  "cancelReason.INSUFFICIENT_LIQUIDITY": "สภาพคล่องไม่เพียงพอ",
  "cancelReason.EXPIRED": "หมดอายุ",
  "cancelReason.MARKET_CLOSED": "ตลาดปิดแล้ว",
  "cancelReason.FAK_REMAINDER": "ยกเลิกส่วนที่จับคู่ทันทีไม่ได้",
  "cancelReason.INVALID_PRICE": "ราคาไม่ถูกต้อง",
  "cancelReason.INVALID_QUANTITY": "จำนวนไม่ถูกต้อง",
  "cancelReason.PRICE_OUT_OF_RANGE": "ราคาอยู่นอกช่วงที่กำหนด",
  "cancelReason.TICK_VIOLATION": "ราคาไม่ตรงตามขั้นราคา",
  "cancelReason.PRECISION_VIOLATION": "ทศนิยมเกินกำหนด",
  "cancelReason.MIN_AMOUNT_VIOLATION": "ต่ำกว่ายอดขั้นต่ำ",
  "cancelReason.INVALID_COMBO": "เงื่อนไขคำสั่งรวมกันไม่ได้",
  "cancelReason.FILLED": "จับคู่ครบแล้ว",
  "cancelReason.CANCELLED_BEFORE_ACTIVATION": "ยกเลิกก่อนการจัดหาเงินจะเสร็จสิ้น",
  "cancelReason.RESOLUTION_UNFILLABLE": "ตลาดสิ้นสุดก่อนการจัดหาเงินจะเสร็จสิ้น",
  "cancelReason.STRANDED_BEFORE_ENGINE": "คำสั่งไม่ถึงตลาด",
  "cancelReason.ORDER_000101": "คำขอส่งคำสั่งไม่ถูกต้อง",
  "cancelReason.ORDER_000102": "ประเภทราคาไม่ถูกต้อง",
  "cancelReason.ORDER_000103": "ระยะเวลาคำสั่งไม่ถูกต้อง",
  "cancelReason.ORDER_000104": "ฝั่งคำสั่งไม่ถูกต้อง",
  "cancelReason.ORDER_000105": "คำสั่งแบบกำหนดราคาไม่มีราคา",
  "cancelReason.ORDER_000106": "คำสั่งแบบกำหนดวันหมดอายุไม่มีวันหมดอายุ",
  "cancelReason.ORDER_000107": "เงื่อนไขคำสั่งรวมกันไม่ได้",
  "cancelReason.ORDER_000108": "จำนวนไม่ถูกต้อง",
  "cancelReason.ORDER_000109": "ราคาไม่ถูกต้อง",
  "cancelReason.ORDER_000110": "รหัสคำสั่งของลูกค้าซ้ำ",
  "cancelReason.ORDER_000111": "คำสั่งซ้ำ",
  "cancelReason.ORDER_000112": "บัญชีผู้ใช้ไม่ได้ใช้งานอยู่",
  "cancelReason.ORDER_000113": "ตลาดหยุดซื้อขายชั่วคราว",
  "cancelReason.ORDER_000114": "อีเวนต์ยังไม่เปิดให้ซื้อขาย",
  "cancelReason.ORDER_000115": "เกินวงเงินความเสี่ยง",
  "cancelReason.ORDER_000116": "ยอดเงินหรือตั๋วไม่พอ",
  "cancelReason.ORDER_000117": "ส่งคำสั่งไปยังตลาดไม่ได้",
  "cancelReason.ORDER_000118": "ระบบจับคู่คำสั่งปฏิเสธ",
  "cancelReason.ORDER_000119": "ตลาดไม่ตอบกลับ",
  "cancelReason.ORDER_000120": "ไม่พบคำสั่ง",
  "cancelReason.ORDER_000121": "คำสั่งสิ้นสุดไปแล้ว",
  "cancelReason.ORDER_000122": "บันทึกคำสั่งไม่ได้",
  "cancelReason.ORDER_000123": "บริการที่เกี่ยวข้องไม่พร้อมใช้งาน",
  "cancelReason.ORDER_000124": "ไม่ได้เข้าสู่ระบบ",
  "cancelReason.ORDER_000125": "ไม่ได้รับอนุญาต",
  "cancelReason.ORDER_000126": "ส่งการแจ้งสถานะไม่สำเร็จ",
  "cancelReason.ORDER_000127": "ผลลัพธ์ไม่ตรงกับตลาด",
  "cancelReason.ORDER_000128": "ตั๋วสำหรับขายไม่พอ",
  "cancelReason.ORDER_000129": "ไม่ได้เลือกผลลัพธ์",
  "cancelReason.ORDER_000130": "ปิดการซื้อขายโหมดเกมอยู่",
  "cancelReason.ORDER_000131": "โหมดนี้ไม่เปิดในตลาดนี้",
  "cancelReason.EXTERNAL_CREDIT_MODE_UNSUPPORTED": "บัญชีเครดิตภายนอกใช้ไม่ได้",
  "cancelReason.BROKER_EXPOSURE_EXCEEDED": "เกินวงเงินความเสี่ยงของโบรกเกอร์",
  "cancelReason.BROKER_EXPOSURE_UNAVAILABLE": "อ่านวงเงินความเสี่ยงคงเหลือไม่ได้",
  "cancelReason.FUNDING_AUTHORIZATION_MISMATCH": "การจัดหาเงินไม่ตรงกับคำสั่ง",
  "cancelReason.FUNDING_AUTHORIZATION_STALE": "การจัดหาเงินสิ้นสุดไปแล้ว",
  "cancelReason.FUNDING_AUTHORIZATION_UNRESOLVED": "การจัดหาเงินไม่ได้รับการยืนยัน",
  "cancelReason.FUNDING_REJECTED": "ผู้ให้บริการปฏิเสธการจัดหาเงิน",
  "auditAction.CREATE": "สร้าง",
  "auditAction.CREATED": "สร้าง",
  "auditAction.UPDATE": "ปรับปรุง",
  "auditAction.UPDATE_SETTINGS": "ปรับปรุงการตั้งค่า",
  "auditAction.BROKER_CURRENCY_IMAGE_SET": "เปลี่ยนรูปสกุลเงิน",
  "auditAction.BROKER_CURRENCY_IMAGE_REMOVED": "ลบรูปสกุลเงิน",
  "auditAction.APPROVE": "อนุมัติ",
  "auditAction.APPROVED": "อนุมัติแล้ว",
  "auditAction.APPROVAL": "บันทึกการอนุมัติ",
  "auditAction.PAUSE": "ระงับชั่วคราว",
  "auditAction.RESUME": "กลับมาใช้งาน",
  "auditAction.BEGIN_CLOSE": "เริ่มปิด",
  "auditAction.CLOSE": "ปิด",
  "auditAction.MOVE": "ย้ายในลำดับชั้น",
  "auditAction.ENSURE": "ตั้งค่าเริ่มต้น",
  "auditAction.ISSUE": "ออก",
  "auditAction.ROTATE": "หมุนเวียนคีย์",
  "auditAction.REVOKE": "เพิกถอน",
  "auditAction.INVITE": "เชิญ",
  "auditAction.ACTIVATE": "เปิดใช้งาน",
  "auditAction.SUSPEND": "ระงับ",
  "auditAction.REMOVE": "นำออก",
  "auditAction.CHANGE_ROLE": "เปลี่ยนบทบาท",
  "auditAction.PENDING": "รอดำเนินการ",
  "auditAction.COMMITTED": "ดำเนินการแล้ว",
  "auditAction.FAILED": "ล้มเหลว",
  "auditAction.MANUAL_REVIEW": "ส่งตรวจสอบด้วยตนเอง",
  "auditAction.REQUEST": "ส่งคำขอ",
  "auditAction.REJECT": "ปฏิเสธ",
  "auditAction.REJECTED": "ปฏิเสธแล้ว",
  "auditAction.CANCEL": "ยกเลิก",
  "auditAction.CANCELLED": "ยกเลิกแล้ว",
  "auditAction.APPLY": "นำไปใช้",
  "auditAction.APPLIED": "นำไปใช้แล้ว",
  "auditAction.POSTED": "บันทึกบัญชีแล้ว",
  "auditAction.PUBLISH": "เผยแพร่",
  "auditAction.RETIRE": "เลิกใช้",
  "auditAction.ASSIGN": "กำหนด",
  "auditAction.CLEAR": "ล้างการกำหนด",
  "auditAction.ESCROWED": "กันเงินไว้แล้ว",
  "auditAction.ESCROW_REFUSED": "การกันเงินถูกปฏิเสธ",
  "auditAction.EXECUTED": "ดำเนินการจ่ายแล้ว",
  "auditAction.PAID": "จ่ายแล้ว",
  "auditAction.RESTORED": "คืนยอดแล้ว",
  "auditAction.HOLD": "ระงับไว้",
  "auditAction.RELEASE_HOLD": "ปลดการระงับ",
  "auditAction.RECORD": "บันทึก",
  "auditAction.CONFIRM": "ยืนยัน",
  "auditAction.OPEN": "เปิด",
  "auditAction.ACKNOWLEDGE": "รับทราบ",
  "auditAction.SETTLED": "ชำระแล้ว",
  "auditAction.WRITTEN_OFF": "ตัดจำหน่ายแล้ว",
  "auditAction.REQUEST_SETTLE": "ขอชำระ",
  "auditAction.REQUEST_WRITE_OFF": "ขอตัดจำหน่าย",
  "auditAction.RESEND_INVITE": "ส่งคำเชิญอีกครั้ง",
  "auditAction.STATEMENT_EXPORTED": "ส่งออกรายงาน",
  "orders.reasonOther": "เหตุผลอื่น",
  "settlement.refresh": "รีเฟรช",
  "transfer.failed": "การโอนไม่สำเร็จ",
  "poolStatus.ACTIVE": "ใช้งานอยู่",
  "poolStatus.FROZEN": "ถูกอายัด",
  "poolStatus.CLOSED": "ปิดแล้ว",
};
